"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2236],{

/***/ 26776:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ sendContactRequest; },
/* harmony export */   "_": function() { return /* binding */ sendMediaStats; }
/* harmony export */ });
/* harmony import */ var _builds_hermes_platform_build_hermes_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5001);
/* harmony import */ var _builds_hermes_platform_build_hermes_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_hermes_platform_build_hermes_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _request__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66548);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}


var internalApi = "https://www.doctify.com";
var sendContactRequest = function() {
    var _ref = _asyncToGenerator(_builds_hermes_platform_build_hermes_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var lang, slug, requestType, source, isPractice, practiceId, specialistId, email, phone, externalBookingLink, _requestHeaders, requestHeaders;
        return _builds_hermes_platform_build_hermes_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    lang = param.lang, slug = param.slug, requestType = param.requestType, source = param.source, isPractice = param.isPractice, practiceId = param.practiceId, specialistId = param.specialistId, email = param.email, phone = param.phone, externalBookingLink = param.externalBookingLink, _requestHeaders = param.requestHeaders, requestHeaders = _requestHeaders === void 0 ? {} : _requestHeaders;
                    return _ctx.abrupt("return", (0,_request__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("".concat(internalApi, "/").concat(lang, "/api/").concat(isPractice ? "practices" : "specialists", "/").concat(slug, "/contact-request"), {
                        method: "post",
                        body: JSON.stringify({
                            requestType: requestType,
                            source: source,
                            specialistId: specialistId,
                            practiceId: practiceId,
                            email: email,
                            phone: phone,
                            externalBookingLink: externalBookingLink
                        }),
                        headers: _objectSpread({
                            "Content-Type": "application/json"
                        }, requestHeaders)
                    }).then(function(r) {
                        return r.status === 201;
                    }).catch(function() {
                        return false;
                    }));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function sendContactRequest(_) {
        return _ref.apply(this, arguments);
    };
}();
var sendMediaStats = function() {
    var _ref = _asyncToGenerator(_builds_hermes_platform_build_hermes_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var locale, mediaId, specialistId, practiceId, type, duration;
        return _builds_hermes_platform_build_hermes_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    locale = param.locale, mediaId = param.mediaId, specialistId = param.specialistId, practiceId = param.practiceId, type = param.type, duration = param.duration;
                    return _ctx.abrupt("return", (0,_request__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("".concat(internalApi, "/").concat(locale, "/api/media/stats"), {
                        method: "post",
                        body: JSON.stringify({
                            mediaId: mediaId,
                            specialistId: specialistId,
                            practiceId: practiceId,
                            type: type,
                            duration: duration
                        }),
                        headers: {
                            "Content-Type": "application/json"
                        }
                    }).then(function(r) {
                        return r.status === 201;
                    }).catch(function() {
                        return false;
                    }));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function sendMediaStats(_) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 75183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* binding */ getSpecialtyBySlug; }
});

// UNUSED EXPORTS: getSpecialties

// EXTERNAL MODULE: ../../../node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(5001);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
;// CONCATENATED MODULE: ./utils/correctorKeywordName.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var correctorRelatedKeywordName = function(language) {
    return function(item) {
        var ref, ref1;
        return _objectSpread({}, item, {
            name: _defineProperty({}, language, item === null || item === void 0 ? void 0 : (ref = item.name) === null || ref === void 0 ? void 0 : (ref1 = ref[language]) === null || ref1 === void 0 ? void 0 : ref1.trim())
        });
    };
};
var fixProfileKeyword = function(item, language) {
    var ref;
    return _objectSpread({}, item, {
        relatedKeywords: (ref = item.relatedKeywords) === null || ref === void 0 ? void 0 : ref.map(correctorRelatedKeywordName(language))
    });
};

// EXTERNAL MODULE: ./api/request.ts
var request = __webpack_require__(66548);
;// CONCATENATED MODULE: ./api/specialties.ts
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var basePath = "https://www.doctify.com/webapi";
var internalApi = "https://www.doctify.com";
var getSpecialties = function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(param) {
        var lang;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    lang = param.lang;
                    return _ctx.abrupt("return", (0,request/* default */.Z)("".concat(internalApi, "/").concat(lang, "/api/filters/specialties")).then(function(r) {
                        return r.json();
                    }));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getSpecialties(_) {
        return _ref.apply(this, arguments);
    };
}();
var getSpecialtyBySlug = function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(param) {
        var language, locale, slug, distance, lat, lon, searchParams, queryParams, url, response;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    language = param.language, locale = param.locale, slug = param.slug, distance = param.distance, lat = param.lat, lon = param.lon;
                    searchParams = new URLSearchParams();
                    if (distance) {
                        searchParams.append("distance", distance);
                    }
                    if (lat) {
                        searchParams.append("lat", lat);
                    }
                    if (lon) {
                        searchParams.append("lon", lon);
                    }
                    queryParams = searchParams.toString();
                    url = "".concat(basePath, "/").concat(locale, "/search/keyword/").concat(slug);
                    if (queryParams === null || queryParams === void 0 ? void 0 : queryParams.length) {
                        url += "?".concat(queryParams);
                    }
                    _ctx.next = 10;
                    return (0,request/* default */.Z)(url).then(function(r) {
                        return r.json();
                    });
                case 10:
                    response = _ctx.sent;
                    if (!(!response || response.statusCode && response.statusCode !== 200)) {
                        _ctx.next = 14;
                        break;
                    }
                    console.error("Error getSpecialtyBySlug: ", response);
                    return _ctx.abrupt("return", null);
                case 14:
                    return _ctx.abrupt("return", fixProfileKeyword(response, language));
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getSpecialtyBySlug(_) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 61697:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74512);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32735);
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58521);
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26025);
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(75320);
/* harmony import */ var _Icons_ChevronRightIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99412);
/* harmony import */ var _hooks_useTranslateMessage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57419);





function Breadcrumbs(param) {
    var items = param.items;
    var translate = (0,_hooks_useTranslateMessage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        "aria-label": "breadcrumbs",
        sx: {
            ".MuiBreadcrumbs-ol": {
                rowGap: "12px"
            }
        },
        separator: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icons_ChevronRightIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            reflectIfRtl: true,
            fontSize: "small"
        }),
        children: items.map(function(item) {
            var label = item.label;
            if (item.label.includes("***")) {
                var splitedBreadcrum = item.label.split("***");
                label = translate("breadcrumbs_in_label", {
                    keyword: splitedBreadcrum[0],
                    city: splitedBreadcrum[1]
                });
            }
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                href: item.url,
                color: "inherit",
                sx: {
                    textDecoration: "none"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    variant: "body2",
                    color: "primary.textBlack700",
                    children: decodeURI(label)
                })
            }, "breadcrumb-".concat(item.label, "-").concat(item.url));
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Breadcrumbs);


/***/ }),

/***/ 19293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74512);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32735);
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84857);
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26546);
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15819);
/* harmony import */ var _ContentTopContainer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39512);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}




var borderBox = "border-box";
var zeroPadding = "0 !important";
var FullWidthElement = (0,_hermes_web_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    shouldForwardProp: function(prop) {
        return ![
            "screenWidth",
            "ignorePadding",
            "mobileOnly"
        ].includes(prop);
    }
})(function(param) {
    var theme = param.theme, screenWidth = param.screenWidth, ignorePadding = param.ignorePadding, mobileOnly = param.mobileOnly;
    var styles = mobileOnly ? {} : {
        // todo: fix lint
        // eslint-disable-next-line sonarjs/no-nested-template-literals
        marginLeft: "calc(-100vw / 2 + (".concat(screenWidth || "".concat(theme.breakpoints.values.xl, "px"), " - ").concat(theme.spacing(10), ") / 2)"),
        width: "100vw",
        boxSizing: borderBox,
        paddingLeft: zeroPadding,
        paddingRight: zeroPadding
    };
    if (!screenWidth) {
        if (!mobileOnly) {
            styles[theme.breakpoints.down("xl")] = {
                marginLeft: "calc(-100vw / 2 + (".concat(theme.breakpoints.values.lg, "px - ").concat(theme.spacing(10), ") / 2)")
            };
            styles[theme.breakpoints.down("lg")] = {
                marginLeft: "calc(-100vw / 2 + (".concat(ignorePadding ? "100vw" : "".concat(theme.breakpoints.values.sm, "px"), " - ").concat(theme.spacing(ignorePadding ? 0 : 8), ") / 2)")
            };
            styles[theme.breakpoints.down("md")] = {
                marginLeft: "calc(-100vw / 2 + (".concat(ignorePadding ? "100vw" : "".concat(theme.breakpoints.values.sm, "px"), " - ").concat(theme.spacing(ignorePadding ? 0 : 6), ") / 2)")
            };
            styles[theme.breakpoints.down("sm")] = {
                marginLeft: "calc(-100vw / 2 + (100vw - ".concat(ignorePadding ? "0px" : theme.spacing(4), ") / 2)")
            };
        } else {
            styles[theme.breakpoints.down("lg")] = {
                marginLeft: "calc(-100vw / 2 + (".concat(ignorePadding ? "100vw" : "".concat(theme.breakpoints.values.sm, "px"), " - ").concat(theme.spacing(ignorePadding ? 0 : 8), ") / 2)"),
                width: "100vw",
                boxSizing: borderBox,
                paddingLeft: zeroPadding,
                paddingRight: zeroPadding
            };
            styles[theme.breakpoints.down("md")] = {
                marginLeft: "calc(-100vw / 2 + (".concat(ignorePadding ? "100vw" : "".concat(theme.breakpoints.values.sm, "px"), " - ").concat(theme.spacing(ignorePadding ? 0 : 6), ") / 2)")
            };
            styles[theme.breakpoints.down("sm")] = {
                marginLeft: "calc(-100vw / 2 + (100vw - ".concat(ignorePadding ? "0px" : theme.spacing(4), ") / 2)")
            };
        }
    } else if (screenWidth) {
        if (!mobileOnly) {
            var _obj;
            styles = _objectSpread({}, styles, (_obj = {}, _defineProperty(_obj, theme.breakpoints.up("sm"), {
                marginLeft: "calc(-100vw / 2 + (".concat(screenWidth, " - ").concat(theme.spacing(6), ") / 2)")
            }), _defineProperty(_obj, theme.breakpoints.up("md"), {
                marginLeft: "calc(-100vw / 2 + (".concat(screenWidth, " - ").concat(theme.spacing(8), ") / 2)")
            }), _defineProperty(_obj, theme.breakpoints.up("xl"), {
                marginLeft: "calc(-100vw / 2 + (".concat(screenWidth, " - ").concat(theme.spacing(10), ") / 2)")
            }), _defineProperty(_obj, theme.breakpoints.down("lg"), {
                marginLeft: "calc(-100vw / 2 + ".concat(ignorePadding ? "(100vw - ".concat(theme.spacing(0), ") / 2") : "(".concat(screenWidth, " - ").concat(theme.spacing(0), ") / 2"), ")")
            }), _defineProperty(_obj, theme.breakpoints.down("md"), {
                marginLeft: "calc(-100vw / 2 + ".concat(ignorePadding ? "(100vw - ".concat(theme.spacing(0), ") / 2") : "(".concat(screenWidth, " - ").concat(theme.spacing(4), ") / 2"), ")")
            }), _defineProperty(_obj, theme.breakpoints.down("sm"), {
                marginLeft: "calc(-100vw / 2 + (".concat(screenWidth, " - ").concat(ignorePadding ? "0px" : theme.spacing(4), ") / 2)")
            }), _obj));
        } else {
            var _obj1;
            styles = _objectSpread({}, styles, (_obj1 = {}, _defineProperty(_obj1, theme.breakpoints.down("lg"), {
                width: "100vw",
                boxSizing: borderBox,
                paddingLeft: zeroPadding,
                paddingRight: zeroPadding,
                marginLeft: "calc(-100vw / 2 + (".concat(screenWidth, " - ").concat(theme.spacing(0), ") / 2)")
            }), _defineProperty(_obj1, theme.breakpoints.down("md"), {
                width: "100vw",
                boxSizing: borderBox,
                paddingLeft: zeroPadding,
                paddingRight: zeroPadding,
                marginLeft: "calc(-100vw / 2 + (".concat(screenWidth, " - ").concat(ignorePadding ? "0px" : theme.spacing(4), ") / 2)")
            }), _defineProperty(_obj1, theme.breakpoints.down("sm"), {
                marginLeft: "calc(-100vw / 2 + (".concat(screenWidth, " - ").concat(ignorePadding ? "0px" : theme.spacing(4), ") / 2)")
            }), _obj1));
        }
    }
    return styles;
});
function FullWidthContainer(param) {
    var children = param.children, divider = param.divider, _ignorePadding = param.ignorePadding, ignorePadding = _ignorePadding === void 0 ? false : _ignorePadding, _sx = param.sx, sx = _sx === void 0 ? {} : _sx, id = param.id, mobileOnly = param.mobileOnly, containerSx = param.containerSx;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), screenWidth = ref1[0], setScreenWidth = ref1[1];
    var container = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (container.current) {
            var ref;
            setScreenWidth("".concat(container === null || container === void 0 ? void 0 : (ref = container.current) === null || ref === void 0 ? void 0 : ref.clientWidth, "px"));
        }
        var resizeListener = function() {
            var ref;
            setScreenWidth("".concat(container === null || container === void 0 ? void 0 : (ref = container.current) === null || ref === void 0 ? void 0 : ref.clientWidth, "px"));
        };
        window.addEventListener("resize", resizeListener);
        return function() {
            window.removeEventListener("resize", resizeListener);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(FullWidthElement, {
        screenWidth: screenWidth,
        ignorePadding: ignorePadding,
        sx: sx,
        id: id,
        mobileOnly: mobileOnly,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ContentTopContainer__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                sx: containerSx,
                maxWidth: "xl",
                ref: container,
                children: children
            }),
            divider && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {})
        ]
    });
}
FullWidthContainer.defaultProps = {
    divider: false
};
/* harmony default export */ __webpack_exports__["Z"] = (FullWidthContainer);


/***/ }),

/***/ 81113:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74512);
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26546);
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75320);
/* harmony import */ var _hooks_useTranslateMessage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57419);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var NextAvailableSlotLabel = function(_param) {
    var children = _param.children, withoutDateTime = _param.withoutDateTime, props = _objectWithoutProperties(_param, [
        "children",
        "withoutDateTime"
    ]);
    var translate = (0,_hooks_useTranslateMessage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({
        ml: "2px",
        mr: "auto",
        display: "flex",
        gap: "8px",
        alignItems: "center"
    }, props, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                width: "16px",
                height: "16px",
                bgcolor: "#00BF7C",
                borderRadius: "50%"
            }),
            withoutDateTime ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                color: "#4C5870",
                lineHeight: "20px",
                children: translate("online_booking_available")
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        color: "#4C5870",
                        lineHeight: "20px",
                        children: translate("booking.next_available_slot")
                    }),
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        color: "#11245A",
                        fontWeight: 500,
                        lineHeight: "20px",
                        children: children
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (NextAvailableSlotLabel);


/***/ }),

/***/ 13219:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useBreadCrumbsSchema; }
});

// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
;// CONCATENATED MODULE: ./utils/schema/breadcrumbs.ts
var stage = "production";
function getBreadcrumbsSchema(breadcrumbs) {
    var suffix = stage === "production" ? "www." : "".concat(stage, ".");
    var itemListElement = breadcrumbs === null || breadcrumbs === void 0 ? void 0 : breadcrumbs.map(function(breadcrumb, index) {
        return {
            "@type": "ListItem",
            position: index + 1,
            item: {
                "@type": "WebPage",
                id: "https://".concat(suffix, "doctify.com").concat(breadcrumb.url),
                name: breadcrumb.label
            }
        };
    });
    return {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: itemListElement
    };
};

;// CONCATENATED MODULE: ./hooks/useBreadcrumbsSchema.ts


function useBreadCrumbsSchema(existingSchema, breadcrumbs) {
    return (0,react.useMemo)(function() {
        if (existingSchema) {
            var schemaObj = JSON.parse(existingSchema);
            if (breadcrumbs && breadcrumbs.length) {
                schemaObj.push(getBreadcrumbsSchema(breadcrumbs));
            }
            return JSON.stringify(schemaObj);
        }
        return JSON.stringify(getBreadcrumbsSchema(breadcrumbs));
    }, [
        existingSchema,
        breadcrumbs
    ]);
};


/***/ }),

/***/ 8443:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ useDateTimeCorrector; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32735);
/* harmony import */ var _utils_date__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12814);


var useDateTimeCorrector = function(datetime) {
    var initialDatetime = (0,_utils_date__WEBPACK_IMPORTED_MODULE_1__/* .getReviewDate */ .nr)(datetime, true);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initialDatetime), dateTime = ref[0], setDateTime = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var correctedDatetime = (0,_utils_date__WEBPACK_IMPORTED_MODULE_1__/* .getReviewDate */ .nr)(datetime);
        setDateTime(correctedDatetime);
    // todo: clarify deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return dateTime;
};


/***/ }),

/***/ 77194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "y": function() { return /* binding */ useSendAnalytic; },
  "Q": function() { return /* binding */ useTrackFiltersValues; }
});

// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ./api/profile.ts
var profile = __webpack_require__(26776);
// EXTERNAL MODULE: ./constants/profile.ts
var constants_profile = __webpack_require__(77225);
// EXTERNAL MODULE: ./providers/AppData/index.tsx
var AppData = __webpack_require__(63040);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/styles/useTheme.esm.js
var useTheme_esm = __webpack_require__(36713);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/system/esm/useMediaQuery/useMediaQuery.esm.js
var useMediaQuery_esm = __webpack_require__(43427);
;// CONCATENATED MODULE: ./hooks/useTrackWindowWidth.ts


var useTrackWindowWidth = function() {
    var theme = (0,useTheme_esm/* default */.Z)();
    var ref = (0,react.useState)(0), windowWidth = ref[0], setWindowWidth = ref[1];
    (0,react.useEffect)(function() {
        return setWindowWidth(window.innerWidth);
    }, []);
    var xs = (0,useMediaQuery_esm/* default */.Z)(theme.breakpoints.down("sm"));
    var sm = (0,useMediaQuery_esm/* default */.Z)(theme.breakpoints.between("sm", "md"));
    var md = (0,useMediaQuery_esm/* default */.Z)(theme.breakpoints.between("md", "lg"));
    var lg = (0,useMediaQuery_esm/* default */.Z)(theme.breakpoints.between("lg", "xl"));
    var xl = (0,useMediaQuery_esm/* default */.Z)(theme.breakpoints.up("xl"));
    return {
        xs: xs,
        sm: sm,
        md: md,
        lg: lg,
        xl: xl,
        isMobile: xs,
        isTablet: md || sm,
        isDesktop: lg || xl,
        width: windowWidth
    };
};

// EXTERNAL MODULE: ./providers/SearchProfilesPage/index.tsx + 1 modules
var SearchProfilesPage = __webpack_require__(34991);
// EXTERNAL MODULE: ./providers/SearchProfilesPage/types.ts
var SearchProfilesPage_types = __webpack_require__(3842);
// EXTERNAL MODULE: ../../../node_modules/next/router.js
var next_router = __webpack_require__(35837);
;// CONCATENATED MODULE: ./hooks/useSendAnalytic.ts








var useSendAnalytic = function(param) {
    var profileSlug = param.profileSlug, specialistId = param.specialistId, practiceId = param.practiceId, _isSpecialist = param.isSpecialist, isSpecialist = _isSpecialist === void 0 ? false : _isSpecialist;
    var router = (0,next_router.useRouter)();
    var isMobile = useTrackWindowWidth().isMobile;
    var ref = (0,react.useContext)(AppData/* AppDataContext */.R), lang = ref.locale;
    var source = isMobile ? constants_profile/* RequestSources.MOBILE */.hY.MOBILE : constants_profile/* RequestSources.DESKTOP */.hY.DESKTOP;
    var slug = profileSlug || router.query.slug;
    return (0,react.useCallback)(function(requestType, value, headers) {
        return (0,profile/* sendContactRequest */.T)({
            requestType: requestType,
            lang: lang,
            source: source,
            isPractice: !isSpecialist,
            slug: slug,
            specialistId: specialistId,
            practiceId: practiceId,
            email: requestType === constants_profile/* RequestTypes.EMAIL */.lO.EMAIL ? value : undefined,
            phone: requestType === constants_profile/* RequestTypes.PHONE */.lO.PHONE ? value : undefined,
            externalBookingLink: requestType === constants_profile/* RequestTypes.EXTERNAL_BOOKING_LINK */.lO.EXTERNAL_BOOKING_LINK ? value : undefined,
            requestHeaders: headers
        });
    }, // todo: clarify deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        isSpecialist,
        lang,
        slug,
        source
    ]);
};
var useTrackFiltersValues = function() {
    var ref2 = (0,react.useContext)(SearchProfilesPage/* SearchProfilesPageContext */.G), _state = ref2.state, filters = _state.filters, typeOfSpecialist = _state.typeOfSpecialist;
    var language = (0,react.useContext)(AppData/* AppDataContext */.R).language;
    return (0,react.useMemo)(function() {
        var ref, ref1;
        var isSpecialistSearch = filters.searchType === SearchProfilesPage_types/* SearchTypes.specialists */.ai.specialists || filters.searchType === SearchProfilesPage_types/* SearchTypes.healthAndSocialCare */.ai.healthAndSocialCare;
        var types = isSpecialistSearch ? typeOfSpecialist : [];
        return {
            fltr_sp_type: ((ref = types.find(function(ts) {
                return ts.id.toString() === filters.specialties[1] || "";
            })) === null || ref === void 0 ? void 0 : (ref1 = ref.name) === null || ref1 === void 0 ? void 0 : ref1[language]) || "All",
            fltr_src_distance: String(filters.distance),
            fltr_appointment_type: filters.appointmentType || "All",
            fltr_gender: filters.gender || "All",
            fltr_language: filters.language || "All",
            fltr_insurance: filters.insurer || "All"
        };
    // todo: clarify deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        filters.appointmentType,
        filters.distance,
        filters.gender,
        filters.insurer,
        filters.language,
        filters.searchType,
        filters.specialties,
        typeOfSpecialist
    ]);
};


/***/ }),

/***/ 854:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ useSpecialistPracticesContacts; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32735);

var useSpecialistPracticesContacts = function(specialistPractices) {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        if (!specialistPractices) {
            return {
                practicesWithBookingLink: [],
                practicesWithContactDetails: []
            };
        }
        return {
            practicesWithBookingLink: specialistPractices.filter(function(practice) {
                return practice.externalBookingLink;
            }),
            practicesWithContactDetails: specialistPractices.filter(function(practice) {
                var _ContactDetails = practice.ContactDetails, ContactDetails = _ContactDetails === void 0 ? [] : _ContactDetails;
                return ContactDetails.findIndex(function(cd) {
                    return [
                        "public",
                        "singlePointPublic"
                    ].includes(cd.type) && (cd.email || cd.phone);
                }) !== -1;
            })
        };
    }, [
        specialistPractices
    ]);
};


/***/ }),

/***/ 72639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useSpecialistWorkingHours; },
/* harmony export */   "i": function() { return /* binding */ dayOfWeekMapping; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32735);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}

var dayOfWeekMapping = {
    monday: 1,
    tuesday: 2,
    wednesday: 3,
    thursday: 4,
    friday: 5,
    saturday: 6,
    sunday: 7
};
function useSpecialistWorkingHours(practices) {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return practices.reduce(function(prev, practice) {
            var workingOpeningHoursPractice = practice.workingOpeningHours, id = practice.id;
            var workingOpeningHours = workingOpeningHoursPractice || {};
            var res = _objectSpread({}, prev, {
                workingHours: _objectSpread({}, prev.workingHours, _defineProperty({}, id, workingOpeningHours))
            });
            Object.keys(workingOpeningHours).forEach(function(key) {
                var ref;
                if ((ref = workingOpeningHours[key]) === null || ref === void 0 ? void 0 : ref.length) {
                    var ref1;
                    res.workingHours.all[Number(key)] = (ref1 = res.workingHours.all[Number(key)]) === null || ref1 === void 0 ? void 0 : ref1.concat(workingOpeningHours[key]);
                    res.hasWorkingHours = true;
                }
            });
            return res;
        }, {
            workingHours: {
                all: {
                    1: [],
                    2: [],
                    3: [],
                    4: [],
                    5: [],
                    6: [],
                    7: []
                }
            },
            hasWorkingHours: false
        });
    }, [
        practices
    ]);
};


/***/ }),

/***/ 45915:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32735);

var useStatistic = function(statistic) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return {
            reviewStatistic: statistic.filter(function(statisticItem) {
                return statisticItem.tagType === "review";
            }),
            peerRecommendationStatistic: statistic.filter(function(statisticItem) {
                return statisticItem.tagType === "peerRecommendation";
            }),
            mergedStatistic: statistic.filter(function(s) {
                return s.tagType === "total";
            })
        };
    }, [
        statistic
    ]), reviewStatistic = ref.reviewStatistic, peerRecommendationStatistic = ref.peerRecommendationStatistic, mergedStatistic = ref.mergedStatistic;
    return {
        reviewStatistic: reviewStatistic,
        peerRecommendationStatistic: peerRecommendationStatistic,
        mergedStatistic: mergedStatistic
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useStatistic);


/***/ }),

/***/ 32107:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "c": function() { return /* binding */ useVisibilityComponents; }
});

// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ./constants/profile.ts
var constants_profile = __webpack_require__(77225);
// EXTERNAL MODULE: ./providers/AppData/index.tsx
var AppData = __webpack_require__(63040);
// EXTERNAL MODULE: ./utils/practiceSpecialist.ts
var practiceSpecialist = __webpack_require__(84990);
// EXTERNAL MODULE: ./hooks/useSpecialistWorkingHours.ts
var useSpecialistWorkingHours = __webpack_require__(72639);
// EXTERNAL MODULE: ./hooks/useSpecialistPractices.ts
var useSpecialistPractices = __webpack_require__(854);
// EXTERNAL MODULE: ./hooks/useKeywordsMapper.ts
var useKeywordsMapper = __webpack_require__(55848);
;// CONCATENATED MODULE: ./utils/getPlanProfile.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}

var planIncludes = function(profile, plans) {
    return plans.some(function(plan) {
        var ref;
        return (ref = profile.plan) === null || ref === void 0 ? void 0 : ref.includes(plan);
    });
};
var getIsUnclaimedPlan = function(profile, type) {
    if (!profile) {
        return null;
    }
    var _obj;
    var unclaimedPlans = (_obj = {}, _defineProperty(_obj, constants_profile/* ProfileTypes.SPECIALIST */.ub.SPECIALIST, [
        constants_profile/* SpecialistPlans.UNCLAIMED */.FS.UNCLAIMED,
        constants_profile/* SpecialistPlans.NO_PLAN */.FS.NO_PLAN
    ]), _defineProperty(_obj, constants_profile/* ProfileTypes.PRACTICE */.ub.PRACTICE, [
        constants_profile/* PracticePlans.UNCLAIMED */.cj.UNCLAIMED,
        constants_profile/* PracticePlans.NO_PLAN */.cj.NO_PLAN
    ]), _obj);
    return planIncludes(profile, unclaimedPlans[type] || []);
};
var getIsProOrExpertProPlan = function(profile, type) {
    if (!profile) {
        return null;
    }
    var _obj;
    var proPlans = (_obj = {}, _defineProperty(_obj, constants_profile/* ProfileTypes.SPECIALIST */.ub.SPECIALIST, [
        constants_profile/* SpecialistPlans.EXPERT */.FS.EXPERT,
        constants_profile/* SpecialistPlans.EXPERT_PRO */.FS.EXPERT_PRO
    ]), _defineProperty(_obj, constants_profile/* ProfileTypes.PRACTICE */.ub.PRACTICE, [
        constants_profile/* PracticePlans.ENTRY */.cj.ENTRY,
        constants_profile/* PracticePlans.UNCLAIMED */.cj.UNCLAIMED
    ]), _obj);
    if (type === constants_profile/* ProfileTypes.PRACTICE */.ub.PRACTICE) {
        return !planIncludes(profile, proPlans[type] || []);
    }
    return planIncludes(profile, proPlans[type] || []);
};

// EXTERNAL MODULE: ./utils/extractFacilitiesTypes.ts + 6 modules
var extractFacilitiesTypes = __webpack_require__(34461);
// EXTERNAL MODULE: ./hooks/useWpaTenant.ts
var useWpaTenant = __webpack_require__(55677);
;// CONCATENATED MODULE: ./hooks/useVisibilityComponents.ts










var isMediaIncludeEnabledArticle = function(type, media) {
    return !!(media === null || media === void 0 ? void 0 : media.some(function(post) {
        return post.type === type && post.enabled;
    }));
};
var useVisibilityComponents = function(param) {
    var specialist = param.specialist, practice1 = param.practice, address = param.address;
    var ref7, ref1;
    var language = (0,react.useContext)(AppData/* AppDataContext */.R).language;
    var ref2 = (0,useSpecialistWorkingHours/* default */.Z)((specialist === null || specialist === void 0 ? void 0 : specialist.practices) || []), specialistHasWoringHours = ref2.hasWorkingHours;
    var ref3 = (0,extractFacilitiesTypes/* default */.Z)((practice1 === null || practice1 === void 0 ? void 0 : practice1.practiceFacilities) || [], language), facilities = ref3.facilities, services = ref3.services, parking = ref3.parking;
    var practicesWithContactDetails = (0,useSpecialistPractices/* useSpecialistPracticesContacts */.t)((specialist === null || specialist === void 0 ? void 0 : specialist.practices) || []).practicesWithContactDetails;
    var ref4 = (0,useKeywordsMapper/* useKeywordsMapper */._)((specialist === null || specialist === void 0 ? void 0 : specialist.keywords) || (practice1 === null || practice1 === void 0 ? void 0 : practice1.keywords) || [], !!practice1), subSpecialties = ref4.subSpecialties, conditionAndTreatments = ref4.conditionAndTreatments;
    var isWPA = (0,useWpaTenant/* useWpaTenant */.c)().isWPA;
    var isUnclaimed = (0,react.useMemo)(function() {
        if (!!practice1 && !specialist) {
            return getIsUnclaimedPlan(practice1, constants_profile/* ProfileTypes.PRACTICE */.ub.PRACTICE);
        }
        if (!!specialist && !practice1) {
            return getIsUnclaimedPlan(specialist, constants_profile/* ProfileTypes.SPECIALIST */.ub.SPECIALIST);
        }
        return true;
    }, [
        practice1,
        specialist
    ]);
    var isBasic = (0,react.useMemo)(function() {
        return (specialist === null || specialist === void 0 ? void 0 : specialist.basic) || (practice1 === null || practice1 === void 0 ? void 0 : practice1.basic);
    }, [
        specialist,
        practice1
    ]);
    var fees = (0,react.useMemo)(function() {
        if (specialist) {
            var ref, ref5, ref6;
            return !isWPA && !isBasic && !isUnclaimed && !!((ref = specialist.consultationFees) === null || ref === void 0 ? void 0 : ref.currency) && (!!((ref5 = specialist.consultationFees) === null || ref5 === void 0 ? void 0 : ref5.followUp) || !!((ref6 = specialist.consultationFees) === null || ref6 === void 0 ? void 0 : ref6.new));
        }
        return false;
    // todo: clarify deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isBasic,
        isUnclaimed,
        specialist === null || specialist === void 0 ? void 0 : (ref7 = specialist.consultationFees) === null || ref7 === void 0 ? void 0 : ref7.currency
    ]);
    var insurers = (0,react.useMemo)(function() {
        var ref, ref8;
        return (!!(practice1 === null || practice1 === void 0 ? void 0 : (ref = practice1.insurers) === null || ref === void 0 ? void 0 : ref.length) || !!(specialist === null || specialist === void 0 ? void 0 : (ref8 = specialist.insurers) === null || ref8 === void 0 ? void 0 : ref8.length)) && !isBasic && !isWPA;
    }, [
        isBasic,
        isWPA,
        specialist === null || specialist === void 0 ? void 0 : specialist.insurers,
        practice1 === null || practice1 === void 0 ? void 0 : practice1.insurers
    ]);
    var about = (0,react.useMemo)(function() {
        var startPermission = !!(subSpecialties === null || subSpecialties === void 0 ? void 0 : subSpecialties.length) || !!(conditionAndTreatments === null || conditionAndTreatments === void 0 ? void 0 : conditionAndTreatments.length) || !!isUnclaimed || !!isBasic || !!fees || !!insurers;
        if (specialist) {
            var ref, ref9, ref10, ref11, ref12, ref13, ref14;
            return startPermission || !!((ref = specialist.about) === null || ref === void 0 ? void 0 : ref[language]) || !!((ref9 = specialist.statistic) === null || ref9 === void 0 ? void 0 : ref9.length) || !!((ref10 = specialist.registrationBodies) === null || ref10 === void 0 ? void 0 : ref10.length) || !!((ref11 = specialist.insurers) === null || ref11 === void 0 ? void 0 : ref11.length) || !!((ref12 = specialist.languages) === null || ref12 === void 0 ? void 0 : ref12.length) || !!((ref13 = specialist.education) === null || ref13 === void 0 ? void 0 : (ref14 = ref13[language]) === null || ref14 === void 0 ? void 0 : ref14.length);
        }
        if (practice1) {
            var ref15, ref16, ref17, ref18, ref19;
            return startPermission || !!((ref15 = practice1.about) === null || ref15 === void 0 ? void 0 : ref15[language]) || !!((ref16 = practice1.keywords) === null || ref16 === void 0 ? void 0 : ref16.length) || !!((ref17 = practice1.insurers) === null || ref17 === void 0 ? void 0 : ref17.length) || !!((ref18 = practice1.statistic) === null || ref18 === void 0 ? void 0 : ref18.length) || !!((ref19 = practice1.healthChecks) === null || ref19 === void 0 ? void 0 : ref19.length);
        }
        return false;
    // todo: clarify deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        conditionAndTreatments,
        isUnclaimed,
        isBasic,
        fees,
        insurers,
        specialist === null || specialist === void 0 ? void 0 : specialist.statistic,
        specialist === null || specialist === void 0 ? void 0 : specialist.registrationBodies,
        specialist === null || specialist === void 0 ? void 0 : specialist.insurers,
        specialist === null || specialist === void 0 ? void 0 : specialist.languages,
        practice1 === null || practice1 === void 0 ? void 0 : practice1.keywords,
        practice1 === null || practice1 === void 0 ? void 0 : practice1.insurers,
        practice1 === null || practice1 === void 0 ? void 0 : practice1.statistic,
        practice1 === null || practice1 === void 0 ? void 0 : practice1.healthChecks
    ]);
    var isProOrExpertPro = (0,react.useMemo)(function() {
        if (specialist) {
            return getIsProOrExpertProPlan(specialist, constants_profile/* ProfileTypes.SPECIALIST */.ub.SPECIALIST);
        }
        if (practice1) {
            return getIsProOrExpertProPlan(practice1, constants_profile/* ProfileTypes.PRACTICE */.ub.PRACTICE);
        }
        return false;
    }, [
        specialist,
        practice1
    ]);
    var peerRecommendations = (0,react.useMemo)(function() {
        return Boolean(specialist && specialist.peerRecommendationsCount);
    }, // todo: clarify deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        specialist,
        specialist === null || specialist === void 0 ? void 0 : specialist.peerRecommendations
    ]);
    var location = (0,react.useMemo)(function() {
        var ref21, ref20;
        return !!address || !!(specialist === null || specialist === void 0 ? void 0 : (ref21 = specialist.practices) === null || ref21 === void 0 ? void 0 : ref21.length) && (specialist === null || specialist === void 0 ? void 0 : (ref20 = specialist.practices) === null || ref20 === void 0 ? void 0 : ref20.some(function(practice) {
            var ref;
            return !!((ref = practice.address) === null || ref === void 0 ? void 0 : ref.geolocation);
        })) || !!(practice1 === null || practice1 === void 0 ? void 0 : practice1.address);
    }, [
        specialist === null || specialist === void 0 ? void 0 : specialist.practices,
        practice1,
        address
    ]);
    var reviewsTotal = (0,react.useMemo)(function() {
        return !!(practice1 === null || practice1 === void 0 ? void 0 : practice1.reviewsTotal) || !!(specialist === null || specialist === void 0 ? void 0 : specialist.reviewsTotal);
    }, [
        practice1 === null || practice1 === void 0 ? void 0 : practice1.reviewsTotal,
        specialist === null || specialist === void 0 ? void 0 : specialist.reviewsTotal
    ]);
    var gallery = (0,react.useMemo)(function() {
        var ref, ref22;
        return !!(practice1 === null || practice1 === void 0 ? void 0 : (ref = practice1.images) === null || ref === void 0 ? void 0 : (ref22 = ref.images) === null || ref22 === void 0 ? void 0 : ref22.length);
    }, [
        practice1 === null || practice1 === void 0 ? void 0 : (ref1 = practice1.images) === null || ref1 === void 0 ? void 0 : ref1.images
    ]);
    var practiceSpecialistName = (0,react.useMemo)(function() {
        var ref;
        return practice1 ? !!(0,practiceSpecialist/* getPracticeSpecialistName */.V)((ref = practice1.specialists) === null || ref === void 0 ? void 0 : ref[0], language) : false;
    }, // todo: clarify deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        practice1,
        practice1 === null || practice1 === void 0 ? void 0 : practice1.specialists
    ]);
    var languages = (0,react.useMemo)(function() {
        var ref;
        return !!(specialist === null || specialist === void 0 ? void 0 : (ref = specialist.languages) === null || ref === void 0 ? void 0 : ref.length);
    }, [
        specialist === null || specialist === void 0 ? void 0 : specialist.languages
    ]);
    // todo: clarify deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var mainPracticeName = (0,react.useMemo)(function() {
        var ref, ref23, ref24;
        return !!(specialist === null || specialist === void 0 ? void 0 : (ref = specialist.practices) === null || ref === void 0 ? void 0 : (ref23 = ref[0]) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.name) === null || ref24 === void 0 ? void 0 : ref24[language]);
    }, [
        specialist === null || specialist === void 0 ? void 0 : specialist.practices
    ]);
    var hasWorkingHours = (0,react.useMemo)(function() {
        var ref, ref25;
        return specialistHasWoringHours || !!(practice1 === null || practice1 === void 0 ? void 0 : (ref = practice1.workingOpeningHours) === null || ref === void 0 ? void 0 : (ref25 = ref[1]) === null || ref25 === void 0 ? void 0 : ref25.length);
    }, [
        specialistHasWoringHours,
        practice1 === null || practice1 === void 0 ? void 0 : practice1.workingOpeningHours
    ]);
    var phone = (0,react.useMemo)(function() {
        return !!(practice1 === null || practice1 === void 0 ? void 0 : practice1.phone);
    }, [
        practice1 === null || practice1 === void 0 ? void 0 : practice1.phone
    ]);
    var practiceSpecialists = (0,react.useMemo)(function() {
        var ref;
        return !!(practice1 === null || practice1 === void 0 ? void 0 : (ref = practice1.specialists) === null || ref === void 0 ? void 0 : ref.length);
    }, [
        practice1 === null || practice1 === void 0 ? void 0 : practice1.specialists
    ]);
    var hideGetInTouch = (0,react.useMemo)(function() {
        var ref, ref26, ref27;
        return !(practicesWithContactDetails === null || practicesWithContactDetails === void 0 ? void 0 : practicesWithContactDetails.length) && !(!!(practice1 === null || practice1 === void 0 ? void 0 : (ref = practice1.phone) === null || ref === void 0 ? void 0 : ref.length) && !!(practice1 === null || practice1 === void 0 ? void 0 : (ref26 = practice1.email) === null || ref26 === void 0 ? void 0 : ref26.length) || !!(practice1 === null || practice1 === void 0 ? void 0 : (ref27 = practice1.plan) === null || ref27 === void 0 ? void 0 : ref27.includes(constants_profile/* PracticePlans.NO_PLAN */.cj.NO_PLAN)));
    }, [
        practicesWithContactDetails,
        practice1 === null || practice1 === void 0 ? void 0 : practice1.phone,
        practice1 === null || practice1 === void 0 ? void 0 : practice1.email,
        practice1 === null || practice1 === void 0 ? void 0 : practice1.plan
    ]);
    var hasSpecialistMedia = (0,react.useMemo)(function() {
        var ref;
        return !!(specialist === null || specialist === void 0 ? void 0 : (ref = specialist.media) === null || ref === void 0 ? void 0 : ref.length);
    }, [
        specialist === null || specialist === void 0 ? void 0 : specialist.media
    ]);
    var hasSpecialistMediaEnabled = (0,react.useMemo)(function() {
        var ref;
        return specialist === null || specialist === void 0 ? void 0 : (ref = specialist.media) === null || ref === void 0 ? void 0 : ref.reduce(function(acc, mediaItem) {
            if (mediaItem.type !== constants_profile/* MediaTypes.PUBLICATION */.Tr.PUBLICATION && mediaItem.enabled) {
                return true;
            }
            return acc;
        }, false);
    }, [
        specialist === null || specialist === void 0 ? void 0 : specialist.media
    ]);
    var hasPracticeMedia = (0,react.useMemo)(function() {
        var ref;
        return !!(practice1 === null || practice1 === void 0 ? void 0 : (ref = practice1.media) === null || ref === void 0 ? void 0 : ref.length);
    }, [
        practice1 === null || practice1 === void 0 ? void 0 : practice1.media
    ]);
    var hasPracticeMediaEnabled = (0,react.useMemo)(function() {
        var ref;
        return practice1 === null || practice1 === void 0 ? void 0 : (ref = practice1.media) === null || ref === void 0 ? void 0 : ref.reduce(function(acc, mediaItem) {
            if (mediaItem.type !== constants_profile/* MediaTypes.PUBLICATION */.Tr.PUBLICATION && mediaItem.enabled) {
                return true;
            }
            return acc;
        }, false);
    }, [
        practice1 === null || practice1 === void 0 ? void 0 : practice1.media
    ]);
    var practiceSocials = (0,react.useMemo)(function() {
        var ref;
        return practice1 === null || practice1 === void 0 ? void 0 : (ref = practice1.media) === null || ref === void 0 ? void 0 : ref.filter(function(post) {
            return !constants_profile/* mediaTypesWithoutSocials.includes */.kh.includes(post.type) && post.enabled;
        });
    }, [
        practice1 === null || practice1 === void 0 ? void 0 : practice1.media
    ]);
    var specialistSocials = (0,react.useMemo)(function() {
        var ref;
        return specialist === null || specialist === void 0 ? void 0 : (ref = specialist.media) === null || ref === void 0 ? void 0 : ref.filter(function(post) {
            return !constants_profile/* mediaTypesWithoutSocials.includes */.kh.includes(post.type) && post.enabled;
        });
    }, [
        specialist === null || specialist === void 0 ? void 0 : specialist.media
    ]);
    var isSpecialistMediaValid = (0,react.useMemo)(function() {
        return hasSpecialistMedia && hasSpecialistMediaEnabled;
    }, [
        hasSpecialistMedia,
        hasSpecialistMediaEnabled
    ]);
    var isPracticeMediaValid = (0,react.useMemo)(function() {
        return hasPracticeMedia && hasPracticeMediaEnabled;
    }, [
        hasPracticeMedia,
        hasPracticeMediaEnabled
    ]);
    var shouldShowMedia = (0,react.useMemo)(function() {
        return !isWPA && !isUnclaimed && isProOrExpertPro && (isSpecialistMediaValid || isPracticeMediaValid) && (specialistSocials || practiceSocials);
    }, [
        isWPA,
        isUnclaimed,
        isProOrExpertPro,
        isSpecialistMediaValid,
        isPracticeMediaValid,
        specialistSocials,
        practiceSocials
    ]);
    var media = (0,react.useMemo)(function() {
        return Boolean(shouldShowMedia);
    }, [
        shouldShowMedia
    ]);
    var checkMediaTypeAvailability = (0,react.useCallback)(function(type) {
        return media && (isMediaIncludeEnabledArticle(type, specialist === null || specialist === void 0 ? void 0 : specialist.media) || isMediaIncludeEnabledArticle(type, practice1 === null || practice1 === void 0 ? void 0 : practice1.media));
    }, [
        media,
        practice1 === null || practice1 === void 0 ? void 0 : practice1.media,
        specialist === null || specialist === void 0 ? void 0 : specialist.media
    ]);
    var videos = (0,react.useMemo)(function() {
        return checkMediaTypeAvailability(constants_profile/* MediaTypes.VIDEO */.Tr.VIDEO) || checkMediaTypeAvailability(constants_profile/* MediaTypes.PROFILE */.Tr.PROFILE);
    }, [
        checkMediaTypeAvailability
    ]);
    var articles = (0,react.useMemo)(function() {
        return checkMediaTypeAvailability(constants_profile/* MediaTypes.ARTICLE */.Tr.ARTICLE);
    }, [
        checkMediaTypeAvailability
    ]);
    var introductionVideoAvailable = isProOrExpertPro;
    var faqQuestions = {
        faqQuestionReviews: reviewsTotal,
        faqQuestionLanguages: languages,
        faqQuestionWhereLocated: mainPracticeName || practiceSpecialistName,
        faqQuestionsLocation: hasWorkingHours,
        faqQuestionAcceptVisits: !hideGetInTouch,
        faqQuestionPracticePhone: phone,
        faqQuestionConsultants: practiceSpecialists
    };
    var showServices = (0,react.useMemo)(function() {
        return !!services.length && !isUnclaimed;
    }, [
        isUnclaimed,
        services.length
    ]);
    var showFacilities = (0,react.useMemo)(function() {
        return !!facilities.length && !isUnclaimed;
    }, [
        isUnclaimed,
        facilities.length
    ]);
    var showParking = (0,react.useMemo)(function() {
        return !!parking.length && !isUnclaimed;
    }, [
        isUnclaimed,
        parking.length
    ]);
    var showBreadcrumbs = (0,react.useMemo)(function() {
        return !isWPA;
    }, [
        isWPA
    ]);
    return {
        about: about,
        articles: articles,
        fees: fees,
        insurers: insurers,
        location: location,
        reviews: true,
        services: showServices,
        facilities: showFacilities,
        parking: showParking,
        peerRecommendations: peerRecommendations,
        specialists: practiceSpecialists,
        gallery: gallery,
        faq: !isBasic && !isUnclaimed && !isWPA && Object.values(faqQuestions).some(function(value) {
            return value;
        }),
        faqQuestions: faqQuestions,
        videos: videos,
        media: media,
        introductionVideoAvailable: introductionVideoAvailable,
        showBreadcrumbs: showBreadcrumbs
    };
};


/***/ }),

/***/ 34991:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "G": function() { return /* binding */ SearchProfilesPageContext; },
  "f": function() { return /* binding */ SearchProfilesPageProvider; }
});

// EXTERNAL MODULE: ../../../node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(5001);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ../../../node_modules/next/router.js
var next_router = __webpack_require__(35837);
// EXTERNAL MODULE: ./constants/search.ts
var search = __webpack_require__(97014);
// EXTERNAL MODULE: ./utils/query.ts
var query = __webpack_require__(57947);
// EXTERNAL MODULE: ./api/autocomplete.ts
var api_autocomplete = __webpack_require__(78150);
// EXTERNAL MODULE: ./api/specialties.ts + 1 modules
var specialties = __webpack_require__(75183);
// EXTERNAL MODULE: ./providers/AppData/index.tsx
var AppData = __webpack_require__(63040);
// EXTERNAL MODULE: ./utils/findLocation.ts
var findLocation = __webpack_require__(27790);
// EXTERNAL MODULE: ./providers/SearchProfilesPage/types.ts
var types = __webpack_require__(3842);
// EXTERNAL MODULE: ./utils/filteringDataByPlan.ts
var filteringDataByPlan = __webpack_require__(80677);
// EXTERNAL MODULE: ./hooks/useGetUnitsByLocale.ts
var useGetUnitsByLocale = __webpack_require__(87691);
// EXTERNAL MODULE: ./utils/strings.ts
var strings = __webpack_require__(43601);
;// CONCATENATED MODULE: ./hooks/useIsInitialMount.ts

var useIsInitialMount = function() {
    var isInitialMount = (0,react.useRef)(true);
    (0,react.useEffect)(function() {
        isInitialMount.current = false;
    }, []);
    return isInitialMount.current;
};

// EXTERNAL MODULE: ./utils/transformSpecialists.ts
var transformSpecialists = __webpack_require__(70485);
// EXTERNAL MODULE: ./api/request.ts
var request = __webpack_require__(66548);
// EXTERNAL MODULE: ./hooks/useWpaTenant.ts
var useWpaTenant = __webpack_require__(55677);
// EXTERNAL MODULE: ./constants/global.ts
var global = __webpack_require__(76467);
// EXTERNAL MODULE: ./hooks/useFeatureFlags.ts
var useFeatureFlags = __webpack_require__(19227);
// EXTERNAL MODULE: ./utils/transformAutocomplete.ts
var transformAutocomplete = __webpack_require__(23099);
// EXTERNAL MODULE: ./hooks/useTranslateMessage.tsx + 1 modules
var useTranslateMessage = __webpack_require__(57419);
// EXTERNAL MODULE: ./constants/profile.ts
var constants_profile = __webpack_require__(77225);
;// CONCATENATED MODULE: ./providers/SearchProfilesPage/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}























var basicApiUrl = "https://www.doctify.com/webapi";
var generateQuery = function(values) {
    var specialties = _toConsumableArray(values.specialties).concat(_toConsumableArray(values.extraSpecialties ? values.extraSpecialties : []));
    var defaultQuery = {
        distance: values.distance === "nolimit" ? "" : values.distance,
        insurer: values.insurer,
        specialistType: values.specialistType,
        appointmentType: values.appointmentType,
        gender: values.gender,
        feeAgreed: values.feeAgreed,
        premium: values.premium,
        patientsChildren: values.patientsChildren,
        specialties: specialties,
        location: values.location,
        lat: values.lat,
        lon: values.lon,
        sortType: values.sortType,
        type: values.type,
        language: values.language,
        slots: values.slots
    };
    var filters = _objectSpread({}, defaultQuery, {
        limit: search/* NUMBER_PER_PROFILE_REQUEST */.wo,
        offset: (values.page - 1) * search/* NUMBER_PER_PROFILE_REQUEST */.wo
    });
    return {
        routerQuery: (0,query/* transformToQuery */.aR)(defaultQuery),
        apiQuery: (0,query/* transformToQuery */.aR)(filters)
    };
};
// todo: fix complexity
// eslint-disable-next-line complexity
var getDefaultStateFromRouter = function(router, locale, lang, currentLocation, defaultValues) {
    var ref = (0,query/* parseQueryFromString */.p9)(router.asPath), _searchString = ref.searchString, searchString = _searchString === void 0 ? "" : _searchString, _insurer = ref.insurer, insurer = _insurer === void 0 ? "" : _insurer, _distance = ref.distance, distance = _distance === void 0 ? "" : _distance, _specialistType = ref.specialistType, specialistType = _specialistType === void 0 ? "" : _specialistType, _appointmentType = ref.appointmentType, appointmentType = _appointmentType === void 0 ? "" : _appointmentType, _gender = ref.gender, gender = _gender === void 0 ? "" : _gender, _feeAgreed = ref.feeAgreed, feeAgreed = _feeAgreed === void 0 ? false : _feeAgreed, _premium = ref.premium, premium = _premium === void 0 ? false : _premium, _patientsChildren = ref.patientsChildren, patientsChildren = _patientsChildren === void 0 ? false : _patientsChildren, _language = ref.language, language = _language === void 0 ? "" : _language, _locationId = ref.locationId, locationId = _locationId === void 0 ? "" : _locationId, _typeOfSpecialist = ref.typeOfSpecialist, typeOfSpecialist = _typeOfSpecialist === void 0 ? "" : _typeOfSpecialist, _profileType = ref.profileType, profileType = _profileType === void 0 ? types/* ProfileTypes.practices */.ub.practices : _profileType, _specialties = ref.specialties, specialties = _specialties === void 0 ? [] : _specialties, _sortType = ref.sortType, sortType = _sortType === void 0 ? types/* SortType.relevance */.ER.relevance : _sortType, _location = ref.location, location = _location === void 0 ? (defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.location) || "" : _location, _treatment = ref.treatment, treatment = _treatment === void 0 ? "" : _treatment, _slots = ref.slots, slots = _slots === void 0 ? false : _slots;
    var ref1 = _slicedToArray((0,query/* parseParamsFromPath */.O8)(router.asPath), 3), locationString = ref1[2];
    var extMode = locationString.startsWith("ext-");
    var ref2 = extMode ? (0,findLocation/* extractLocationProps */.ym)(locationString) : currentLocation || {
        lat: "51.4776721",
        lon: "0.1648559"
    }, _lat = ref2.lat, lat = _lat === void 0 ? "" : _lat, _lon = ref2.lon, lon = _lon === void 0 ? "" : _lon;
    return {
        page: Number((defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.page) || router.query.page || 1),
        searchString: (defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.searchString) || searchString,
        distance: distance || "",
        insurer: (defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.insurer) || insurer,
        specialistType: (defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.specialistType) || specialistType,
        appointmentType: (defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.appointmentType) || appointmentType,
        gender: (defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.gender) || gender,
        feeAgreed: (defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.feeAgreed) || feeAgreed === "true",
        premium: (defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.premium) || premium === "false",
        slots: (defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.slots) || slots === "true",
        patientsChildren: (defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.patientsChildren) || patientsChildren === "true",
        specialties: (defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.specialties) || specialties,
        language: (defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.language) || language,
        profileType: (defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.profileType) || profileType,
        searchType: (defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.searchType) || types/* SearchTypes.practices */.ai.practices,
        sortType: (defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.sortType) || sortType,
        location: (defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.location) || extMode ? location : searchString || currentLocation.name[lang],
        locationId: (defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.locationId) || locationId,
        childLocations: [],
        breadcrumb: [],
        lat: (defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.lat) || lat,
        lon: (defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.lon) || lon,
        typeOfSpecialist: (defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.typeOfSpecialist) || typeOfSpecialist,
        treatment: (defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.treatment) || treatment,
        selectedKeyword: (defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.selectedKeyword) || "",
        urlKeyword: (defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.urlKeyword) || ""
    };
};
var getHashParams = function(hash) {
    var hashParams = new URLSearchParams(hash.replace("#", ""));
    return Array.from(hashParams.entries()).reduce(function(params, param) {
        var _param = _slicedToArray(param, 2), key = _param[0], value = _param[1];
        return _objectSpread({}, params, _defineProperty({}, key, value));
    }, {});
};
var SearchProfilesPageContext = /*#__PURE__*/ (0,react.createContext)({
    state: {
        specialists: [],
        practices: [],
        specialistsAutocomplete: [],
        practicesAutocomplete: [],
        specialties: [],
        conditionsProcedures: [],
        locations: [],
        relatedKeywords: [],
        typeOfSpecialist: [],
        // @ts-ignore //TODO: temp
        specialty: undefined,
        isMainKeywordConditionOrProcedure: false,
        totalProfiles: 0,
        filters: {
            searchType: types/* SearchTypes.practices */.ai.practices,
            profileType: types/* ProfileTypes.practices */.ub.practices,
            searchString: "",
            specialistType: "",
            distance: "",
            appointmentType: "",
            gender: "",
            feeAgreed: false,
            premium: false,
            patientsChildren: false,
            slots: false,
            language: "",
            selectedKeyword: "",
            location: "",
            locationId: "",
            parentLocation: "",
            childLocations: [],
            breadcrumb: [],
            lat: "",
            lon: "",
            insurer: "",
            page: 1,
            specialties: [],
            sortType: types/* SortType.relevance */.ER.relevance,
            typeOfSpecialist: "",
            treatment: "",
            urlKeyword: ""
        },
        isLoading: false,
        isKeywordChanged: false,
        isTypeChanged: false,
        isLocationChanged: false,
        isEmptyResponse: false,
        shouldShowSuggested: true,
        clientReloaded: false
    },
    searchKeywordTitle: "",
    resetLocationsAutocomplete: function() {
        return null;
    },
    changeFilter: function(key, val) {
        return {
            key: key,
            val: val
        };
    },
    changeSearch: function(search) {
        return search;
    },
    changeKeyword: function() {},
    changeType: function() {},
    changeLocation: function() {},
    changeLocationSearch: function(search, language) {
        return {
            search: search,
            language: language
        };
    },
    changeLocationCoordinates: function(lat, lon) {
        return {
            lat: lat,
            lon: lon
        };
    },
    changePage: function(page) {
        return page;
    },
    changeSpecialty: function(id, slug, procedureOrCondition) {
        return {
            id: id,
            slug: slug,
            procedureOrCondition: procedureOrCondition
        };
    },
    changeTypeOfSpecialist: function(id) {
        return id;
    },
    changeSearchType: function(searchType) {
        return searchType;
    },
    changeCurrentLocation: function(locationId) {
        return locationId;
    },
    openProfilePage: function(slug) {
        return slug;
    },
    reloadData: function() {},
    loadCurrentLocationByLatLon: function() {
        return Promise.resolve();
    }
});
// todo: fix complexity
// eslint-disable-next-line complexity
function SearchProfilesPageProvider(param1) {
    var children = param1.children, initialSpecialists = param1.specialists, initialPractices = param1.practices, defaultFilters = param1.defaultFilters, initialRelatedKeywords = param1.relatedKeywords, initialTypeOfSpecialist = param1.typeOfSpecialist, isMainKeywordConditionOrProcedure = param1.isMainKeywordConditionOrProcedure, initSpecialty = param1.specialty, totalProfiles = param1.totalProfiles, practiceSponsors = param1.practiceSponsors, suggestedSpecialists = param1.suggestedSpecialists, suggestedPractices = param1.suggestedPractices, specialistsSponsors = param1.specialistsSponsors, breadcrumb = param1.breadcrumb, currentLocation = param1.currentLocation, conditionsAndProcedures = param1.conditionsAndProcedures, specialties1 = param1.specialties, defaultLocation = param1.defaultLocation, locationsAutocomplete = param1.locationsAutocomplete, distance = param1.distance;
    var ref8, ref3, ref4, ref5;
    var ref6 = (0,react.useContext)(AppData/* AppDataContext */.R), locale = ref6.locale, lang = ref6.language, tenantSettings = ref6.tenantSettings;
    var tranlate = (0,useTranslateMessage/* default */.Z)();
    var router = (0,next_router.useRouter)();
    var isInitialMount = useIsInitialMount();
    var getUnitsByLocale = (0,useGetUnitsByLocale/* useGetUnitsByLocale */.N)();
    var isWPA = (0,useWpaTenant/* useWpaTenant */.c)().isWPA;
    var alternativeSearchEnabled = (0,useFeatureFlags/* useFeatureFlags */.g)().alternativeSearchEnabled;
    var parseQueryString = function(queryString) {
        var urlParts = queryString.split("#")[queryString.split("#").length - 1];
        var parameters = urlParts.split("&");
        return parameters.reduce(function(result, param) {
            var ref = _slicedToArray(param.split("="), 2), key = ref[0], value = ref[1];
            if (key === "premium") {
                result[key] = value === "true";
                return result;
            }
            result[key] = decodeURIComponent(value === null || value === void 0 ? void 0 : value.replace(/\+/g, " "));
            return result;
        }, {});
    };
    if (initSpecialty.name[lang] === "ABSTRACT_TOP_LEVEL_KEYWORD") {
        // eslint-disable-next-line no-param-reassign
        initSpecialty.name[lang] = "";
    }
    if (initSpecialty.name[lang] === "ABSTRACT_TOP_LEVEL_KEYWORD") {
        // eslint-disable-next-line no-param-reassign
        initSpecialty.name[lang] = "";
    }
    var ref7 = (0,react.useState)({
        specialists: initialSpecialists || [],
        practices: initialPractices || [],
        currentLocation: currentLocation,
        specialistsAutocomplete: [],
        practicesAutocomplete: [],
        practiceSponsors: practiceSponsors,
        suggestedSpecialists: suggestedSpecialists,
        suggestedPractices: suggestedPractices,
        specialistsSponsors: specialistsSponsors,
        specialties: specialties1 || [],
        defaultLocation: defaultLocation,
        conditionsProcedures: (currentLocation ? conditionsAndProcedures === null || conditionsAndProcedures === void 0 ? void 0 : conditionsAndProcedures.filter(function(item) {
            return item.id !== 152;
        }) : conditionsAndProcedures) || [],
        relatedKeywords: initialRelatedKeywords || [],
        typeOfSpecialist: initialTypeOfSpecialist || [],
        locations: locationsAutocomplete || [],
        filters: _objectSpread({}, getDefaultStateFromRouter(router, locale, lang, currentLocation, defaultFilters), {
            searchString: (initSpecialty === null || initSpecialty === void 0 ? void 0 : (ref8 = initSpecialty.name) === null || ref8 === void 0 ? void 0 : ref8[lang]) || "",
            profileType: defaultFilters.profileType,
            breadcrumb: breadcrumb,
            urlKeyword: defaultFilters.urlKeyword,
            distance: distance || "nolimit",
            parentLocation: (breadcrumb === null || breadcrumb === void 0 ? void 0 : breadcrumb.length) ? (ref3 = breadcrumb[breadcrumb.length - 2]) === null || ref3 === void 0 ? void 0 : ref3.label : undefined,
            searchType: defaultFilters.profileType === types/* ProfileTypes.specialists */.ub.specialists ? types/* SearchTypes.specialists */.ai.specialists : (0,strings/* compareStrings */.A5)(initSpecialty.name[lang], (tenantSettings === null || tenantSettings === void 0 ? void 0 : (ref4 = tenantSettings.search) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.DENTISTRY) === null || ref5 === void 0 ? void 0 : ref5.name) || "") && defaultFilters.urlKeyword !== "all" && types/* SearchTypes.dentist */.ai.dentist || defaultFilters.profileType
        }),
        isLoading: false,
        isKeywordChanged: false,
        isTypeChanged: false,
        isLocationChanged: false,
        shouldShowSuggested: true,
        isEmptyResponse: false,
        isMainKeywordConditionOrProcedure: isMainKeywordConditionOrProcedure,
        specialty: initSpecialty,
        totalProfiles: totalProfiles,
        clientReloaded: false
    }), state = ref7[0], setState = ref7[1];
    var buildUrl = (0,react.useCallback)(// todo: fix complexity
    // eslint-disable-next-line complexity
    function(params) {
        var _resetSearch = params.resetSearch, resetSearch = _resetSearch === void 0 ? false : _resetSearch;
        var keywordSlug = params.keywordSlug || state.filters.urlKeyword;
        var procedureConditionSlug = params.procedureConditionSlug || params.procedureConditionSlug !== null && state.filters.treatment || "";
        var lat = typeof params.lat !== "undefined" ? params.lat : state.filters.lat;
        var lon = typeof params.lon !== "undefined" ? params.lon : state.filters.lon;
        var location = typeof params.location !== "undefined" ? params.location : state.filters.location;
        var distanceParam = typeof params.distance !== "undefined" && params.distance !== "0" && params.distance;
        var appointmentType = typeof params.appointmentType !== "undefined" ? params.appointmentType : state.filters.appointmentType;
        var typeOfSpecialist = typeof params.typeOfSpecialist !== "undefined" ? params.typeOfSpecialist : state.filters.specialties[1];
        var language = typeof params.language !== "undefined" ? params.language : state.filters.language;
        var gender = typeof params.gender !== "undefined" ? params.gender : state.filters.gender;
        var insurer = typeof params.insurer !== "undefined" ? params.insurer : state.filters.insurer;
        var profileType = (0,transformAutocomplete/* transformSearchType */.lT)(typeof params.profileType !== "undefined" ? params.profileType : state.filters.profileType);
        var premium = typeof params.premium !== "undefined" ? params.premium : state.filters.premium;
        var slots = typeof params.slots !== "undefined" ? params.slots : state.filters.slots;
        var feeAgreed = typeof params.feeAgreed !== "undefined" ? params.feeAgreed : state.filters.feeAgreed;
        var patientsChildren = typeof params.patientsChildren !== "undefined" ? params.patientsChildren : state.filters.patientsChildren;
        var sortType = typeof params.sortType !== "undefined" ? params.sortType : state.filters.sortType;
        var page = params.page;
        var hashQueryParams = new Map();
        if (procedureConditionSlug) {
            hashQueryParams.set("treatment", procedureConditionSlug);
        }
        if (location && (location === null || location === void 0 ? void 0 : location.length)) {
            hashQueryParams.set("location", location);
        }
        if (distanceParam && typeof distanceParam !== "number" && (distanceParam === null || distanceParam === void 0 ? void 0 : distanceParam.length)) {
            hashQueryParams.set("distance", distanceParam);
        }
        if (sortType && (sortType === null || sortType === void 0 ? void 0 : sortType.length)) {
            hashQueryParams.set("sortType", sortType);
        }
        if (slots) {
            hashQueryParams.set("slots", true);
        }
        if (profileType === "specialists") {
            if (patientsChildren) {
                hashQueryParams.set("patientsChildren", true);
            }
            if (feeAgreed) {
                hashQueryParams.set("feeAgreed", true);
            }
            if (appointmentType && (appointmentType === null || appointmentType === void 0 ? void 0 : appointmentType.length)) {
                hashQueryParams.set("appointmentType", appointmentType);
            }
            if (typeOfSpecialist && typeOfSpecialist.length) {
                hashQueryParams.set("typeOfSpecialist", typeOfSpecialist);
            }
            if (gender && (gender === null || gender === void 0 ? void 0 : gender.length)) {
                hashQueryParams.set("gender", gender);
            }
            if (language) {
                hashQueryParams.set("language", language);
            }
        }
        if (profileType === "practices" && !premium) {
            hashQueryParams.set("premium", false);
        }
        if (insurer) {
            hashQueryParams.set("insurer", insurer);
        }
        var hashQueryString = "";
        if (hashQueryParams.size > 0) {
            hashQueryString = Array.from(hashQueryParams).map(function(param) {
                var _param = _slicedToArray(param, 2), key = _param[0], value = _param[1];
                return "".concat(key, "=").concat(value);
            }).join("&");
        }
        var locationString = "ext-".concat(lat, "-").concat(lon);
        if (params.slug) {
            locationString = params.slug;
        }
        var url = "/".concat(router.locale, "/find/").concat(keywordSlug, "/").concat(locationString, "/").concat(profileType);
        if (page && page > 1) {
            url += "/page-".concat(page);
        }
        if (hashQueryString && !resetSearch) {
            url += "#".concat(hashQueryString);
        }
        return url;
    }, // todo: clarify deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        state.filters
    ]);
    var checkClientReloadPossibility = (0,react.useCallback)(function(hash) {
        var hashParams = getHashParams(hash);
        var hashKeys = Object.keys(hashParams).sort();
        var hashDistance = hashParams.distance;
        var allowedQueries = [
            types/* SearchQueries.treatment */.iR.treatment,
            types/* SearchQueries.location */.iR.location
        ];
        var isInternalLocation = !!currentLocation;
        var internalLocationDistance = String(currentLocation === null || currentLocation === void 0 ? void 0 : currentLocation.searchDistance);
        var isDefaultLocationDistance = isInternalLocation ? hashDistance === internalLocationDistance : hashDistance === search/* DEFAULT_SEARCH_DISTANCE */.XD;
        if (isDefaultLocationDistance) {
            allowedQueries.push(types/* SearchQueries.distance */.iR.distance);
        }
        var allValid = hashKeys.every(function(query) {
            return allowedQueries.includes(query);
        });
        var containsAtLeastOneValidElement = hashKeys.some(function(query) {
            return allowedQueries.includes(query);
        });
        return allValid && containsAtLeastOneValidElement || !hashKeys.length;
    }, [
        currentLocation
    ]);
    var isSpecialistSearch = (0,react.useMemo)(function() {
        var profileType = state.filters.profileType;
        return profileType === types/* ProfileTypes.specialists */.ub.specialists || profileType === types/* ProfileTypes.healthAndSocialCare */.ub.healthAndSocialCare;
    }, [
        state.filters.profileType
    ]);
    (0,react.useEffect)(function() {
        var filters = defaultFilters;
        var disallowClientLoading = checkClientReloadPossibility(window.location.hash);
        var hash = new URL(window.location.href).hash;
        var splitedHash = hash.replace("#", "").split("&").map(function(item) {
            var ref = _slicedToArray(item.split("="), 2), key = ref[0], value = ref[1];
            return {
                key: key,
                value: value
            };
        }) || [];
        var filtersToAdd = {};
        splitedHash.forEach(function(f) {
            filtersToAdd[f.key] = f.value;
        });
        var treatmentKeyword = initialRelatedKeywords.find(function(item) {
            return item.slug[0] === (filtersToAdd === null || filtersToAdd === void 0 ? void 0 : filtersToAdd.treatment);
        });
        var typeOfSpecialist = filtersToAdd.typeOfSpecialist;
        var typeOfSpecialistId = typeof typeOfSpecialist !== "undefined" ? typeOfSpecialist : undefined;
        var defaultSpecialties = filters.specialties;
        var specialties = ((defaultSpecialties === null || defaultSpecialties === void 0 ? void 0 : defaultSpecialties.length) >= 1 ? _toConsumableArray(defaultSpecialties).concat([
            typeOfSpecialistId
        ]) : Array.from({
            length: 2
        }).fill(typeOfSpecialistId)).filter(Boolean);
        setState(function(prev) {
            return _objectSpread({}, prev, {
                filters: _objectSpread({}, prev.filters, {
                    specialties: treatmentKeyword ? _toConsumableArray(prev.filters.specialties[0]).concat([
                        treatmentKeyword.id.toString()
                    ]) : specialties
                }, filtersToAdd)
            });
        });
        if (!disallowClientLoading) {
            setState(function(prev) {
                return _objectSpread({}, prev, {
                    isLoading: true,
                    isEmptyResponse: false,
                    clientReloaded: true
                });
            });
        }
    // todo: clarify deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        defaultFilters
    ]);
    (0,react.useEffect)(function() {
        setState(function(prevState) {
            return _objectSpread({}, prevState, {
                filters: _objectSpread({}, prevState.filters, {
                    distance: prevState.filters.distance || (currentLocation ? currentLocation.searchDistance || "nolimit" : "25")
                })
            });
        });
    // todo: clarify deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        locationsAutocomplete
    ]);
    var changeFilter = function(key, value) {
        var ref;
        setState(function(prev) {
            var _obj;
            return _objectSpread({}, prev, {
                isLoading: true,
                clientReloaded: true,
                isEmptyResponse: false,
                filters: _objectSpread({}, prev.filters, (_obj = {}, _defineProperty(_obj, key, value), _defineProperty(_obj, "page", 1), _obj))
            });
        });
        var _obj1;
        var url = buildUrl((_obj1 = {
            distance: state.filters.distance
        }, _defineProperty(_obj1, key, value), _defineProperty(_obj1, "slug", currentLocation === null || currentLocation === void 0 ? void 0 : currentLocation.slug), _defineProperty(_obj1, "location", currentLocation === null || currentLocation === void 0 ? void 0 : (ref = currentLocation.name) === null || ref === void 0 ? void 0 : ref[lang]), _obj1));
        window.history.pushState({}, "", url);
    };
    var changeKeyword = function() {
        setState(function(prev) {
            return _objectSpread({}, prev, {
                isKeywordChanged: true
            });
        });
    };
    var changeType = function() {
        setState(function(prev) {
            return _objectSpread({}, prev, {
                isTypeChanged: true
            });
        });
    };
    var changeLocation = function() {
        setState(function(prev) {
            return _objectSpread({}, prev, {
                isLocationChanged: true
            });
        });
    };
    var changePage = function(page) {
        setState(function(prev) {
            return _objectSpread({}, prev, {
                filters: _objectSpread({}, prev.filters, {
                    page: page
                })
            });
        });
    };
    var openProfilePage = function(slug) {
        window.open("/".concat(router.locale, "/").concat(isSpecialistSearch ? "specialist" : "practice", "/").concat(slug), "_blank");
    };
    var reloadData = function() {
        setState(function(prev) {
            return _objectSpread({}, prev, {
                isLoading: true,
                isEmptyResponse: false
            });
        });
    };
    var changeSpecialty = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(id, slug) {
            var procedureOrCondition, ref11, ref9, ref10, specialtyResponse, parentSpecialtySlugs, keywordSlug, url, specialtyResponse1, _args = arguments;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        procedureOrCondition = _args.length > 2 && _args[2] !== void 0 ? _args[2] : false;
                        ;
                        if (!procedureOrCondition) {
                            _ctx.next = 13;
                            break;
                        }
                        ;
                        _ctx.next = 6;
                        return (0,specialties/* getSpecialtyBySlug */.E)({
                            language: lang,
                            locale: locale,
                            slug: slug
                        });
                    case 6:
                        specialtyResponse = _ctx.sent;
                        parentSpecialtySlugs = specialtyResponse === null || specialtyResponse === void 0 ? void 0 : (ref9 = specialtyResponse.typeOfSpecialist) === null || ref9 === void 0 ? void 0 : ref9.map(function(kw) {
                            var ref;
                            return kw === null || kw === void 0 ? void 0 : (ref = kw.slug) === null || ref === void 0 ? void 0 : ref[0];
                        });
                        keywordSlug = (parentSpecialtySlugs === null || parentSpecialtySlugs === void 0 ? void 0 : parentSpecialtySlugs.includes(state.filters.urlKeyword)) ? undefined : specialtyResponse === null || specialtyResponse === void 0 ? void 0 : specialtyResponse.slug[0];
                        setState(function(prev) {
                            return _objectSpread({}, prev, {
                                isLoading: true,
                                isEmptyResponse: false,
                                filters: _objectSpread({}, prev.filters, {
                                    typeOfSpecialist: "",
                                    // distance: DEFAULT_SEARCH_DISTANCE,
                                    appointmentType: "",
                                    gender: "",
                                    language: "",
                                    patientsChildren: false,
                                    feeAgreed: false,
                                    premium: false,
                                    slots: false,
                                    insurer: "",
                                    page: 1,
                                    specialties: state.filters.specialties.includes(id) ? _toConsumableArray(state.filters.specialties.filter(function(item) {
                                        return item !== id;
                                    })).concat([
                                        state.specialty.id.toString()
                                    ]) : [
                                        (prev.filters.specialties[0], id)
                                    ],
                                    treatment: procedureOrCondition ? slug : "",
                                    urlKeyword: procedureOrCondition ? slug : ""
                                })
                            });
                        });
                        url = buildUrl({
                            slug: currentLocation === null || currentLocation === void 0 ? void 0 : currentLocation.slug,
                            location: currentLocation === null || currentLocation === void 0 ? void 0 : (ref10 = currentLocation.name) === null || ref10 === void 0 ? void 0 : ref10[lang],
                            procedureConditionSlug: state.filters.specialties.includes(id) ? null : slug,
                            keywordSlug: keywordSlug
                        });
                        router.push("/find/[...search]", url, {
                            shallow: true
                        });
                        return _ctx.abrupt("return", url);
                    case 13:
                        _ctx.next = 15;
                        return (0,specialties/* getSpecialtyBySlug */.E)({
                            language: lang,
                            locale: locale,
                            slug: slug
                        });
                    case 15:
                        specialtyResponse1 = _ctx.sent;
                        setState(function(prev) {
                            return _objectSpread({}, prev, {
                                isLoading: true,
                                isEmptyResponse: false,
                                specialty: (specialtyResponse1 === null || specialtyResponse1 === void 0 ? void 0 : specialtyResponse1.id) && specialtyResponse1 || prev.specialty,
                                typeOfSpecialist: (specialtyResponse1 === null || specialtyResponse1 === void 0 ? void 0 : specialtyResponse1.id) && (specialtyResponse1 === null || specialtyResponse1 === void 0 ? void 0 : specialtyResponse1.typeOfSpecialist) || prev.typeOfSpecialist,
                                relatedKeywords: (specialtyResponse1 === null || specialtyResponse1 === void 0 ? void 0 : specialtyResponse1.id) && (specialtyResponse1 === null || specialtyResponse1 === void 0 ? void 0 : specialtyResponse1.relatedKeywords) || prev.relatedKeywords,
                                filters: _objectSpread({}, prev.filters, {
                                    // distance: DEFAULT_SEARCH_DISTANCE,
                                    appointmentType: "",
                                    gender: "",
                                    premium: false,
                                    slots: false,
                                    patientsChildren: false,
                                    feeAgreed: false,
                                    language: "",
                                    insurer: "",
                                    treatment: "",
                                    page: 1,
                                    urlKeyword: slug
                                })
                            });
                        });
                        return _ctx.abrupt("return", buildUrl({
                            slug: currentLocation === null || currentLocation === void 0 ? void 0 : currentLocation.slug,
                            location: currentLocation === null || currentLocation === void 0 ? void 0 : (ref11 = currentLocation.name) === null || ref11 === void 0 ? void 0 : ref11[lang],
                            keywordSlug: slug,
                            procedureConditionSlug: ""
                        }));
                    case 18:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function changeSpecialty(id, slug) {
            return _ref.apply(this, arguments);
        };
    }();
    var changeTypeOfSpecialist = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(id) {
            var ref, typeOfSpecialistId;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        typeOfSpecialistId = id.length > 0 ? [
                            id
                        ] : [];
                        setState(function(prev) {
                            return _objectSpread({}, prev, {
                                isLoading: true,
                                isEmptyResponse: false,
                                filters: _objectSpread({}, prev.filters, {
                                    specialties: [
                                        prev.filters.specialties[0]
                                    ].concat(_toConsumableArray(typeOfSpecialistId)),
                                    typeOfSpecialist: id
                                })
                            });
                        });
                        window.location.href = buildUrl({
                            typeOfSpecialist: id,
                            slug: currentLocation === null || currentLocation === void 0 ? void 0 : currentLocation.slug,
                            location: currentLocation === null || currentLocation === void 0 ? void 0 : (ref = currentLocation.name) === null || ref === void 0 ? void 0 : ref[lang]
                        });
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function changeTypeOfSpecialist(id) {
            return _ref.apply(this, arguments);
        };
    }();
    var searchKeywordTitle = (0,react.useMemo)(function() {
        var ref, ref12, ref13, ref14, ref15;
        var filters = state.filters, specialty = state.specialty;
        var keywordPractitioner = (specialty === null || specialty === void 0 ? void 0 : (ref = specialty.practitioner) === null || ref === void 0 ? void 0 : ref[lang]) ? "".concat((specialty === null || specialty === void 0 ? void 0 : (ref12 = specialty.practitioner) === null || ref12 === void 0 ? void 0 : ref12[lang]) || (specialty === null || specialty === void 0 ? void 0 : (ref13 = specialty.practitioner) === null || ref13 === void 0 ? void 0 : ref13.en)).concat(lang === "en" ? "s" : "") : (specialty === null || specialty === void 0 ? void 0 : (ref14 = specialty.name) === null || ref14 === void 0 ? void 0 : ref14[lang]) || tranlate("global.specialist_and_doctors");
        return filters.searchType === types/* SearchTypes.specialists */.ai.specialists || filters.searchType === types/* SearchTypes.healthAndSocialCare */.ai.healthAndSocialCare ? keywordPractitioner : specialty === null || specialty === void 0 ? void 0 : (ref15 = specialty.name) === null || ref15 === void 0 ? void 0 : ref15[lang];
    }, [
        lang,
        state,
        tranlate
    ]);
    var conditionProceduresKey = "conditions-procedures";
    var changeSearch = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(search) {
            var autocomplete, ref19, ref16, ref17, ref18, defaultSearchKeywords;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        _ctx.t0 = state.filters.searchType;
                        _ctx.next = _ctx.t0 === types/* SearchTypes.dentist */.ai.dentist ? 4 : _ctx.t0 === types/* SearchTypes.careHome */.ai.careHome ? 9 : _ctx.t0 === types/* SearchTypes.hospital */.ai.hospital ? 13 : _ctx.t0 === types/* SearchTypes.pharmacy */.ai.pharmacy ? 17 : _ctx.t0 === types/* SearchTypes.healthAndSocialCare */.ai.healthAndSocialCare ? 21 : _ctx.t0 === types/* SearchTypes.practices */.ai.practices ? 25 : 29;
                        break;
                    case 4:
                        ;
                        _ctx.next = 7;
                        return (0,api_autocomplete/* getSearchAutocomplete */.z1)({
                            searchString: search || "dentist",
                            lang: router.locale,
                            specialties: [
                                (tenantSettings === null || tenantSettings === void 0 ? void 0 : (ref19 = tenantSettings.search) === null || ref19 === void 0 ? void 0 : (ref16 = ref19.DENTISTRY) === null || ref16 === void 0 ? void 0 : ref16.id.toString()) || "0"
                            ],
                            searchType: types/* AutocompleteSearchTypes.practice */.O2.practice
                        });
                    case 7:
                        autocomplete = _ctx.sent;
                        return _ctx.abrupt("break", 32);
                    case 9:
                        _ctx.next = 11;
                        return (0,api_autocomplete/* getSearchAutocomplete */.z1)({
                            searchString: search,
                            lang: router.locale,
                            type: types/* SearchTypes.careHome */.ai.careHome,
                            searchType: types/* AutocompleteSearchTypes.practice */.O2.practice
                        });
                    case 11:
                        autocomplete = _ctx.sent;
                        return _ctx.abrupt("break", 32);
                    case 13:
                        _ctx.next = 15;
                        return (0,api_autocomplete/* getSearchAutocomplete */.z1)({
                            searchString: search,
                            lang: router.locale,
                            type: types/* SearchTypes.hospital */.ai.hospital,
                            searchType: types/* AutocompleteSearchTypes.practice */.O2.practice
                        });
                    case 15:
                        autocomplete = _ctx.sent;
                        return _ctx.abrupt("break", 32);
                    case 17:
                        _ctx.next = 19;
                        return (0,api_autocomplete/* getSearchAutocomplete */.z1)({
                            searchString: search,
                            lang: router.locale,
                            type: types/* SearchTypes.pharmacy */.ai.pharmacy,
                            searchType: types/* AutocompleteSearchTypes.practice */.O2.practice
                        });
                    case 19:
                        autocomplete = _ctx.sent;
                        return _ctx.abrupt("break", 32);
                    case 21:
                        _ctx.next = 23;
                        return (0,api_autocomplete/* getSearchAutocomplete */.z1)({
                            searchString: search,
                            lang: router.locale,
                            type: types/* SearchTypes.healthAndSocialCare */.ai.healthAndSocialCare,
                            searchType: types/* AutocompleteSearchTypes.specialist */.O2.specialist
                        });
                    case 23:
                        autocomplete = _ctx.sent;
                        return _ctx.abrupt("break", 32);
                    case 25:
                        _ctx.next = 27;
                        return (0,api_autocomplete/* getSearchAutocomplete */.z1)({
                            searchString: search,
                            lang: router.locale,
                            searchType: types/* AutocompleteSearchTypes.practice */.O2.practice
                        });
                    case 27:
                        autocomplete = _ctx.sent;
                        return _ctx.abrupt("break", 32);
                    case 29:
                        _ctx.next = 31;
                        return (0,api_autocomplete/* getSearchAutocomplete */.z1)({
                            searchString: search,
                            lang: router.locale,
                            searchType: types/* AutocompleteSearchTypes.specialist */.O2.specialist
                        });
                    case 31:
                        autocomplete = _ctx.sent;
                    case 32:
                        if (!(search === "" && alternativeSearchEnabled && !isWPA)) {
                            _ctx.next = 39;
                            break;
                        }
                        ;
                        _ctx.next = 36;
                        return (0,api_autocomplete/* getSearchKeywords */.Fx)({
                            locale: locale,
                            keywordId: state === null || state === void 0 ? void 0 : (ref17 = state.specialty) === null || ref17 === void 0 ? void 0 : ref17.id,
                            keywordType: state === null || state === void 0 ? void 0 : (ref18 = state.specialty) === null || ref18 === void 0 ? void 0 : ref18.type,
                            locationId: currentLocation === null || currentLocation === void 0 ? void 0 : currentLocation.id
                        });
                    case 36:
                        defaultSearchKeywords = _ctx.sent;
                        if (defaultSearchKeywords.specialties) {
                            autocomplete.specialties = defaultSearchKeywords.specialties;
                        }
                        if (defaultSearchKeywords.conditionsAndProcedures) {
                            autocomplete[conditionProceduresKey] = defaultSearchKeywords.conditionsAndProcedures;
                        }
                    case 39:
                        setState(function(prev) {
                            var ref;
                            return _objectSpread({}, prev, {
                                filters: _objectSpread({}, prev.filters, {
                                    searchString: search
                                }),
                                practicesAutocomplete: (autocomplete === null || autocomplete === void 0 ? void 0 : autocomplete.practices) || [],
                                specialistsAutocomplete: (autocomplete === null || autocomplete === void 0 ? void 0 : autocomplete.specialists) || [],
                                specialties: (autocomplete === null || autocomplete === void 0 ? void 0 : autocomplete.specialties) || [],
                                conditionsProcedures: (currentLocation ? autocomplete === null || autocomplete === void 0 ? void 0 : (ref = autocomplete[conditionProceduresKey]) === null || ref === void 0 ? void 0 : ref.filter(function(x) {
                                    return x.id !== 152;
                                }) : autocomplete === null || autocomplete === void 0 ? void 0 : autocomplete[conditionProceduresKey]) || []
                            });
                        });
                    case 40:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function changeSearch(search) {
            return _ref.apply(this, arguments);
        };
    }();
    var loadCurrentLocationByLatLon = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(lat, lon) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        return _ctx.abrupt("return", (0,api_autocomplete/* getLocationsAutocomplete */.iN)({
                            lang: router.locale,
                            lat: lat,
                            lon: lon
                        }).then(function(locations) {
                            setState(function(prev) {
                                return _objectSpread({}, prev, {
                                    locations: locations
                                });
                            });
                        }));
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function loadCurrentLocationByLatLon(lat, lon) {
            return _ref.apply(this, arguments);
        };
    }();
    var changeLocationCoordinates = function(lat, lon, location) {
        var withRouterPush = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true, slug = arguments.length > 4 ? arguments[4] : void 0;
        var url = buildUrl({
            lat: +lat,
            lon: +lon,
            location: location,
            slug: slug
        });
        if (withRouterPush) {
            window.location.href = url;
        }
    };
    var changeLocationSearch = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(search, language) {
            var locations, ref;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(search.length > 3)) {
                            _ctx.next = 17;
                            break;
                        }
                        locations = [];
                        setState(function(prev) {
                            return _objectSpread({}, prev, {
                                locations: locations
                            });
                        });
                        ;
                        if (!isWPA) {
                            _ctx.next = 8;
                            break;
                        }
                        _ctx.t0 = [];
                        _ctx.next = 11;
                        break;
                    case 8:
                        _ctx.next = 10;
                        return (0,api_autocomplete/* getLocationsAutocompleteSelfDatabase */.D4)({
                            search: search,
                            lang: router.locale,
                            locationId: (ref = currentLocation === null || currentLocation === void 0 ? void 0 : currentLocation.id) !== null && ref !== void 0 ? ref : 562,
                            type: state.filters.searchType
                        });
                    case 10:
                        _ctx.t0 = _ctx.sent;
                    case 11:
                        locations = _ctx.t0;
                        if (locations.length) {
                            _ctx.next = 16;
                            break;
                        }
                        _ctx.next = 15;
                        return (0,api_autocomplete/* getLocationsAutocomplete */.iN)({
                            searchString: search,
                            lang: router.locale,
                            language: language
                        });
                    case 15:
                        locations = _ctx.sent;
                    case 16:
                        setState(function(prev) {
                            return _objectSpread({}, prev, {
                                locations: locations
                            });
                        });
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function changeLocationSearch(search, language) {
            return _ref.apply(this, arguments);
        };
    }();
    var resetLocationsAutocomplete = function() {
        setState(function(prevState) {
            return _objectSpread({}, prevState, {
                locations: locationsAutocomplete
            });
        });
    };
    var changeCurrentLocation = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(locationId, locationName, slug) {
            var locationDetails, ref, lat, lng;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        changeLocation();
                        _ctx.next = 3;
                        return (0,api_autocomplete/* getLocationDetails */.U_)({
                            locationId: locationId,
                            lang: router.locale
                        });
                    case 3:
                        locationDetails = _ctx.sent;
                        ref = (locationDetails === null || locationDetails === void 0 ? void 0 : locationDetails.location) || {
                            lat: 0,
                            lng: 0
                        }, lat = ref.lat, lng = ref.lng;
                        changeLocationCoordinates(lat, lng, locationName, true, slug);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function changeCurrentLocation(locationId, locationName, slug) {
            return _ref.apply(this, arguments);
        };
    }();
    var changeSearchTypeUrl = function(searchType) {
        var ref;
        var isDentistry = searchType === types/* SearchTypes.dentist */.ai.dentist;
        var search = tenantSettings === null || tenantSettings === void 0 ? void 0 : tenantSettings.search;
        var dentistrySpecialty = search === null || search === void 0 ? void 0 : search.DENTISTRY;
        var searchTypeFromState = state.filters.searchType;
        var isInNewSearchTypes = global/* newSearchTypesPractices.includes */.Bg.includes(searchType);
        var wasInNewSearchTypes = global/* newSearchTypesPractices.includes */.Bg.includes(searchTypeFromState);
        var isInSearchTypes = global/* searchTypes.includes */.qg.includes(searchType);
        var shouldResetSearch = isInNewSearchTypes || isInSearchTypes && wasInNewSearchTypes;
        var mappedSearchType = alternativeSearchEnabled && !isWPA && searchType ? (0,transformAutocomplete/* transformSearchType */.lT)(searchType) : searchType;
        var profileType = searchType === types/* SearchTypes.dentist */.ai.dentist ? types/* SearchTypes.practices */.ai.practices : mappedSearchType;
        var location = shouldResetSearch ? defaultLocation : state.currentLocation;
        var urlKeywordBuilder = function(urlKeyword) {
            if (isDentistry) {
                return dentistrySpecialty === null || dentistrySpecialty === void 0 ? void 0 : dentistrySpecialty.slug;
            } else if (!isInNewSearchTypes) {
                return urlKeyword;
            } else {
                return "all";
            }
        };
        return buildUrl({
            profileType: profileType,
            slug: (location === null || location === void 0 ? void 0 : location.slug) || "ext-".concat(state.filters.lat, "-").concat(state.filters.lon),
            location: (location === null || location === void 0 ? void 0 : (ref = location.name) === null || ref === void 0 ? void 0 : ref[lang]) || state.filters.location,
            sortType: "",
            keywordSlug: urlKeywordBuilder(state.filters.urlKeyword),
            resetSearch: shouldResetSearch
        });
    };
    var changeSearchType = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(searchType) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(searchType === state.filters.searchType)) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        changeType();
                        window.location.href = changeSearchTypeUrl(searchType);
                        setState(function(prevState) {
                            var isSearchTypeToSetDentistOrPractice = searchType === types/* SearchTypes.dentist */.ai.dentist || searchType === types/* SearchTypes.practices */.ai.practices;
                            var isPreviousSearchTypeToSetDentistOrPractice = prevState.filters.searchType === types/* SearchTypes.dentist */.ai.dentist || prevState.filters.searchType === types/* SearchTypes.practices */.ai.practices;
                            var isTypeChanged = !(isSearchTypeToSetDentistOrPractice && isPreviousSearchTypeToSetDentistOrPractice && searchType !== prevState.filters.searchType);
                            return _objectSpread({}, prevState, {
                                isTypeChanged: isTypeChanged,
                                filters: isTypeChanged ? prevState.filters : _objectSpread({}, prevState.filters, {
                                    searchType: searchType
                                })
                            });
                        });
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function changeSearchType(searchType) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (!isInitialMount) {
            var ref, ref20, ref21, ref22;
            changeLocationSearch(state.filters.location, lang);
            changeSearch(state.filters.searchString);
            if (state.filters.searchType === (tenantSettings === null || tenantSettings === void 0 ? void 0 : (ref = tenantSettings.search) === null || ref === void 0 ? void 0 : (ref20 = ref.DENTISTRY) === null || ref20 === void 0 ? void 0 : ref20.slug) || "") {
                var ref23, ref24, ref25, ref26;
                changeSpecialty((tenantSettings === null || tenantSettings === void 0 ? void 0 : (ref23 = tenantSettings.search) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.DENTISTRY) === null || ref24 === void 0 ? void 0 : ref24.id.toString()) || "", (tenantSettings === null || tenantSettings === void 0 ? void 0 : (ref25 = tenantSettings.search) === null || ref25 === void 0 ? void 0 : (ref26 = ref25.DENTISTRY) === null || ref26 === void 0 ? void 0 : ref26.slug) || "");
            }
            if (state.filters.searchType === (tenantSettings === null || tenantSettings === void 0 ? void 0 : (ref21 = tenantSettings.search) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.CARE_HOME) === null || ref22 === void 0 ? void 0 : ref22.slug) || "") {
                var ref27, ref28, ref29, ref30;
                changeSpecialty((tenantSettings === null || tenantSettings === void 0 ? void 0 : (ref27 = tenantSettings.search) === null || ref27 === void 0 ? void 0 : (ref28 = ref27.CARE_HOME) === null || ref28 === void 0 ? void 0 : ref28.id.toString()) || "", (tenantSettings === null || tenantSettings === void 0 ? void 0 : (ref29 = tenantSettings.search) === null || ref29 === void 0 ? void 0 : (ref30 = ref29.CARE_HOME) === null || ref30 === void 0 ? void 0 : ref30.slug) || "");
            }
        }
    // todo: clarify deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        state.filters.searchType
    ]);
    var getPageIndex = (0,react.useCallback)(function() {
        try {
            var ref;
            var pageSearch = router.query.search;
            return (ref = pageSearch === null || pageSearch === void 0 ? void 0 : pageSearch.pop()) === null || ref === void 0 ? void 0 : ref.replace("page-", "");
        } catch (e) {
            return "0";
        }
    }, [
        router.query.search
    ]);
    (0,react.useEffect)(function() {
        var disallowClientLoading = checkClientReloadPossibility(window.location.hash);
        if (disallowClientLoading) {
            return;
        }
        setState(function(prev) {
            return _objectSpread({}, prev, {
                isLoading: true,
                isEmptyResponse: false,
                clientReloaded: true
            });
        });
    }, [
        checkClientReloadPossibility,
        router.asPath
    ]);
    // Disabled complexity of arrow function eslint check
    // eslint-disable-next-line complexity
    (0,react.useEffect)(function() {
        var extendableFiltersObject = {
            distance: state.filters.distance || "nolimit",
            insurer: state.filters.insurer || "",
            specialistType: state.filters.specialistType || "",
            appointmentType: state.filters.appointmentType || "",
            gender: state.filters.gender || "",
            feeAgreed: state.filters.feeAgreed || false,
            premium: state.filters.premium || false,
            slots: state.filters.slots || false,
            patientsChildren: state.filters.patientsChildren || false,
            location: state.filters.location || "",
            treatment: state.filters.treatment || "",
            language: state.filters.language || "",
            typeOfSpecialist: state.filters.typeOfSpecialist || "",
            lat: state.filters.lat,
            lon: state.filters.lon
        };
        var loadSpecialists = function() {
            var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
                var params, pageIndex, filtersObjectFromURL, filtersFromUrl, specialtyResponse, queryFilters, apiQuery, apiBasePath, specialistFetchUrl, specialistsResponse, specialistsResponseData, filteredProfilesData, shouldShowSuggested, _args = arguments;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            params = _args.length > 0 && _args[0] !== void 0 ? _args[0] : {};
                            pageIndex = getPageIndex();
                            filtersObjectFromURL = parseQueryString(window.location.hash);
                            filtersFromUrl = _objectSpread({}, extendableFiltersObject, filtersObjectFromURL);
                            if (!filtersFromUrl.treatment) {
                                _ctx.next = 10;
                                break;
                            }
                            _ctx.next = 7;
                            return (0,specialties/* getSpecialtyBySlug */.E)({
                                language: lang,
                                locale: locale,
                                slug: filtersFromUrl.treatment,
                                distance: extendableFiltersObject.distance.toString() || distance.toString(),
                                lat: extendableFiltersObject === null || extendableFiltersObject === void 0 ? void 0 : extendableFiltersObject.lat,
                                lon: extendableFiltersObject === null || extendableFiltersObject === void 0 ? void 0 : extendableFiltersObject.lon
                            });
                        case 7:
                            _ctx.t0 = _ctx.sent;
                            _ctx.next = 11;
                            break;
                        case 10:
                            _ctx.t0 = null;
                        case 11:
                            specialtyResponse = _ctx.t0;
                            queryFilters = _objectSpread({}, state.filters, filtersFromUrl, {
                                page: Number(pageIndex) || 1,
                                selectedKeyword: (specialtyResponse === null || specialtyResponse === void 0 ? void 0 : specialtyResponse.name[lang]) || state.filters.selectedKeyword || "",
                                specialties: specialtyResponse ? [
                                    specialtyResponse === null || specialtyResponse === void 0 ? void 0 : specialtyResponse.id.toString(),
                                    state.filters.typeOfSpecialist
                                ].filter(function(x) {
                                    return !!(x === null || x === void 0 ? void 0 : x.length);
                                }) : state.filters.specialties
                            }, params);
                            apiQuery = generateQuery(_objectSpread({}, queryFilters, {
                                page: Number(pageIndex) || 1,
                                specialties: queryFilters.specialties.filter(function(s) {
                                    return s !== undefined;
                                }),
                                distance: getUnitsByLocale(filtersFromUrl.distance).queryDistance
                            })).apiQuery;
                            apiBasePath = "".concat(basicApiUrl, "/").concat(router.locale, "/search/specialists");
                            specialistFetchUrl = apiBasePath;
                            if (apiQuery) {
                                specialistFetchUrl += "?".concat(apiQuery);
                            }
                            _ctx.next = 19;
                            return (0,request/* default */.Z)(specialistFetchUrl).then(function(r) {
                                return r.json();
                            });
                        case 19:
                            specialistsResponse = _ctx.sent;
                            specialistsResponseData = (specialistsResponse === null || specialistsResponse === void 0 ? void 0 : specialistsResponse.data) || [];
                            filteredProfilesData = specialistsResponseData.map(function(specialist) {
                                return (0,filteringDataByPlan/* filteringProfileDataByPlan */.p)({
                                    specialist: specialist
                                });
                            });
                            shouldShowSuggested = filteredProfilesData.every(function(profile) {
                                return (profile === null || profile === void 0 ? void 0 : profile.plan.includes(constants_profile/* SpecialistPlans.UNCLAIMED */.FS.UNCLAIMED)) || (profile === null || profile === void 0 ? void 0 : profile.plan.includes(constants_profile/* SpecialistPlans.ENTRY */.FS.ENTRY));
                            });
                            setState(function(prevState) {
                                return _objectSpread({}, prevState, {
                                    specialists: (0,transformSpecialists/* default */.Z)(filteredProfilesData),
                                    filters: _objectSpread({}, state.filters, queryFilters),
                                    specialty: specialtyResponse || prevState.specialty,
                                    isLoading: false,
                                    isEmptyResponse: filteredProfilesData.length === 0,
                                    totalProfiles: specialistsResponse.total || 0,
                                    shouldShowSuggested: shouldShowSuggested
                                });
                            });
                        case 24:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function loadSpecialists() {
                return _ref.apply(this, arguments);
            };
        }();
        var loadPractices = function() {
            var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
                var params, pageIndex, filtersObjectFromURL, filtersFromUrl, specialtyResponse, queryFilters, apiQuery, fetchUrl, practicesResponse, practicesResponseData, filteredProfilesData, shouldShowSuggested, _args = arguments;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            params = _args.length > 0 && _args[0] !== void 0 ? _args[0] : {};
                            pageIndex = getPageIndex();
                            filtersObjectFromURL = parseQueryString(window.location.hash);
                            filtersFromUrl = _objectSpread({}, extendableFiltersObject, filtersObjectFromURL);
                            if (!filtersFromUrl.treatment) {
                                _ctx.next = 10;
                                break;
                            }
                            _ctx.next = 7;
                            return (0,specialties/* getSpecialtyBySlug */.E)({
                                language: lang,
                                locale: locale,
                                slug: filtersFromUrl.treatment
                            });
                        case 7:
                            _ctx.t0 = _ctx.sent;
                            _ctx.next = 11;
                            break;
                        case 10:
                            _ctx.t0 = null;
                        case 11:
                            specialtyResponse = _ctx.t0;
                            queryFilters = _objectSpread({}, state.filters, filtersFromUrl, {
                                page: Number(pageIndex) || 1,
                                selectedKeyword: (specialtyResponse === null || specialtyResponse === void 0 ? void 0 : specialtyResponse.name[lang]) || state.filters.selectedKeyword || "",
                                specialties: specialtyResponse ? [
                                    specialtyResponse === null || specialtyResponse === void 0 ? void 0 : specialtyResponse.id.toString()
                                ] : state.filters.specialties.filter(function(specialty) {
                                    return specialty !== undefined;
                                })
                            });
                            apiQuery = generateQuery(_objectSpread({}, queryFilters, params, {
                                page: Number(pageIndex) || 1,
                                distance: getUnitsByLocale(queryFilters.distance).queryDistance
                            })).apiQuery;
                            fetchUrl = "".concat(basicApiUrl, "/").concat(router.locale, "/search/practices");
                            if (apiQuery) {
                                fetchUrl += "?".concat(apiQuery);
                            }
                            _ctx.next = 18;
                            return (0,request/* default */.Z)(fetchUrl).then(function(r) {
                                return r.json();
                            });
                        case 18:
                            practicesResponse = _ctx.sent;
                            practicesResponseData = (practicesResponse === null || practicesResponse === void 0 ? void 0 : practicesResponse.data) || [];
                            filteredProfilesData = practicesResponseData.map(function(practice) {
                                return (0,filteringDataByPlan/* filteringProfileDataByPlan */.p)({
                                    practice: practice
                                });
                            });
                            shouldShowSuggested = filteredProfilesData.every(function(profile) {
                                return (profile === null || profile === void 0 ? void 0 : profile.plan.includes(constants_profile/* PracticePlans.ENTRY */.cj.ENTRY)) || (profile === null || profile === void 0 ? void 0 : profile.plan.includes(constants_profile/* PracticePlans.UNCLAIMED */.cj.UNCLAIMED));
                            });
                            setState(function(prevState) {
                                return _objectSpread({}, prevState, {
                                    practices: filteredProfilesData,
                                    filters: _objectSpread({}, state.filters, queryFilters),
                                    specialty: specialtyResponse || prevState.specialty,
                                    isLoading: false,
                                    isEmptyResponse: filteredProfilesData.length === 0,
                                    totalProfiles: practicesResponse.total || 0,
                                    shouldShowSuggested: shouldShowSuggested
                                });
                            });
                        case 23:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function loadPractices() {
                return _ref.apply(this, arguments);
            };
        }();
        if (state.isLoading) {
            switch(state.filters.searchType){
                case types/* SearchTypes.specialists */.ai.specialists:
                    {
                        loadSpecialists();
                        break;
                    }
                case types/* SearchTypes.practices */.ai.practices:
                    {
                        loadPractices();
                        break;
                    }
                case types/* SearchTypes.dentist */.ai.dentist:
                    {
                        var ref, ref31;
                        loadPractices({
                            extraSpecialties: [
                                (tenantSettings === null || tenantSettings === void 0 ? void 0 : (ref = tenantSettings.search) === null || ref === void 0 ? void 0 : (ref31 = ref.DENTISTRY) === null || ref31 === void 0 ? void 0 : ref31.id.toString()) || ""
                            ]
                        });
                        break;
                    }
                case types/* SearchTypes.careHome */.ai.careHome:
                    {
                        loadPractices({
                            type: types/* SearchTypes.careHome */.ai.careHome
                        });
                        break;
                    }
                case types/* SearchTypes.hospital */.ai.hospital:
                    {
                        loadPractices({
                            type: types/* SearchTypes.hospital */.ai.hospital
                        });
                        break;
                    }
                case types/* SearchTypes.pharmacy */.ai.pharmacy:
                    {
                        loadPractices({
                            type: types/* SearchTypes.pharmacy */.ai.pharmacy
                        });
                        break;
                    }
                case types/* SearchTypes.healthAndSocialCare */.ai.healthAndSocialCare:
                    {
                        loadSpecialists({
                            type: types/* SearchTypes.healthAndSocialCare */.ai.healthAndSocialCare
                        });
                        break;
                    }
                default:
                    {
                        loadPractices();
                    }
            }
        }
    // todo: clarify deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        state.isLoading,
        router.asPath
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchProfilesPageContext.Provider, {
        value: {
            state: state,
            searchKeywordTitle: searchKeywordTitle,
            reloadData: reloadData,
            changeSearch: changeSearch,
            changeLocationSearch: changeLocationSearch,
            changeCurrentLocation: changeCurrentLocation,
            changeSearchTypeUrl: changeSearchTypeUrl,
            changeFilter: changeFilter,
            changeKeyword: changeKeyword,
            changeType: changeType,
            changeLocation: changeLocation,
            changePage: changePage,
            changeSpecialty: changeSpecialty,
            changeTypeOfSpecialist: changeTypeOfSpecialist,
            changeSearchType: changeSearchType,
            changeLocationCoordinates: changeLocationCoordinates,
            openProfilePage: openProfilePage,
            resetLocationsAutocomplete: resetLocationsAutocomplete,
            loadCurrentLocationByLatLon: loadCurrentLocationByLatLon,
            buildUrl: buildUrl
        },
        children: children
    });
}



/***/ }),

/***/ 34461:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ utils_extractFacilitiesTypes; }
});

// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/_virtual/_tslib.esm.js
var _tslib_esm = __webpack_require__(10395);
// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/SvgIcon/SvgIcon.esm.js + 1 modules
var SvgIcon_esm = __webpack_require__(46224);
;// CONCATENATED MODULE: ../../../packages/hermes-web-components/lib/icons/Bed/index.esm.js




const BedIcon = (_a) => {
    var props = (0,_tslib_esm/* __rest */._)(_a, []);
    return (react.createElement(SvgIcon_esm/* default */.Z, Object.assign({ width: "24", height: "25", viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react.createElement("mask", { id: "path-1-inside-1_10490_3983", fill: "white" },
            react.createElement("rect", { x: "5.45508", y: "5.2959", width: "13.0909", height: "5.93939", rx: "1" })),
        react.createElement("rect", { x: "5.45508", y: "5.2959", width: "13.0909", height: "5.93939", rx: "1", stroke: "#051851", strokeWidth: "2.4", fill: "none", mask: "url(#path-1-inside-1_10490_3983)" }),
        react.createElement("path", { d: "M3.4 19.2959C3.4 19.6273 3.66863 19.8959 4 19.8959C4.33137 19.8959 4.6 19.6273 4.6 19.2959H3.4ZM4.13789 13.6169L3.62062 13.3129L4.13789 13.6169ZM5.76845 9.65856L3.62062 13.3129L4.65515 13.9209L6.80298 10.2666L5.76845 9.65856ZM3.4 14.1236V19.2959H4.6V14.1236H3.4ZM3.62062 13.3129C3.47617 13.5586 3.4 13.8385 3.4 14.1236H4.6C4.6 14.0523 4.61904 13.9823 4.65515 13.9209L3.62062 13.3129Z", fill: "#051851" }),
        react.createElement("path", { d: "M19.4006 19.2959C19.4006 19.6273 19.6692 19.8959 20.0006 19.8959C20.3319 19.8959 20.6006 19.6273 20.6006 19.2959H19.4006ZM19.8718 13.7921L19.3491 14.0865L19.8718 13.7921ZM17.1921 10.257L19.3491 14.0865L20.3946 13.4976L18.2376 9.66812L17.1921 10.257ZM19.4006 14.2828V19.2959H20.6006V14.2828H19.4006ZM19.3491 14.0865C19.3828 14.1464 19.4006 14.214 19.4006 14.2828H20.6006C20.6006 14.0077 20.5296 13.7373 20.3946 13.4976L19.3491 14.0865Z", fill: "#051851" }),
        react.createElement("path", { d: "M8.36328 10.4929V8.76563C8.36328 8.48948 8.58714 8.26562 8.86328 8.26562H11.9996M15.636 10.4929V8.76562C15.636 8.48948 15.4122 8.26562 15.136 8.26562H11.9996M11.9996 8.26562V10.4929", stroke: "#051851", strokeWidth: "1.2" }),
        react.createElement("path", { d: "M4 14.6292H20M4 18.1292H20", stroke: "#051851", strokeWidth: "1.2" })));
};



;// CONCATENATED MODULE: ../../../packages/hermes-web-components/lib/icons/MoneyBag/index.esm.js




const MoneyBagIcon = (_a) => {
    var props = (0,_tslib_esm/* __rest */._)(_a, []);
    return (react.createElement(SvgIcon_esm/* default */.Z, Object.assign({ width: "24", height: "25", viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react.createElement("path", { d: "M12.6411 21.0469H10.1463C8.5309 21.0469 7.06083 20.114 6.373 18.6523V18.6523C5.76813 17.367 5.85917 15.8621 6.61458 14.6591L10.1217 9.07364L8.59229 4.48535H15.4092L13.7487 9.07364L17.285 14.5534C18.0985 15.814 18.1798 17.4122 17.4984 18.7488V18.7488C16.7795 20.159 15.3303 21.0469 13.7473 21.0469H12.4573", stroke: "#051851", strokeWidth: "1.2", strokeLinecap: "round", strokeLinejoin: "round", fill: "none" }),
        react.createElement("rect", { x: "8.67969", y: "7.67578", width: "6.64209", height: "2.35969", rx: "1.17984", fill: "#051851" }),
        react.createElement("path", { d: "M13.9073 17.4066C14.2164 17.5156 14.2182 17.9559 13.9073 18.0596H10.4913C10.2601 18.0596 10.1611 17.766 10.3437 17.6243C10.5503 17.4136 10.7028 17.2054 10.8011 16.9994C10.8995 16.7888 10.9487 16.529 10.9487 16.2201C10.9487 16.1265 10.9364 16.0282 10.9118 15.9252H10.1002C9.82281 15.8444 9.82281 15.4514 10.1002 15.3705H10.7274C10.6241 15.0757 10.5724 14.7901 10.5724 14.514C10.5724 14.2004 10.6437 13.9289 10.7864 13.6995C10.929 13.4702 11.1258 13.2947 11.3766 13.173C11.6275 13.0466 11.9177 12.9834 12.2473 12.9834C12.7736 12.9834 13.172 13.1238 13.4425 13.4047C13.7131 13.6855 13.8532 14.0436 13.8631 14.4789C13.7702 14.8334 13.2854 14.8788 13.1284 14.5476L13.0958 14.4789C13.0958 14.2261 13.0269 14.0272 12.8892 13.8821C12.7514 13.7323 12.5375 13.6574 12.2473 13.6574C11.9817 13.6574 11.7677 13.73 11.6054 13.8751C11.448 14.0202 11.3693 14.2472 11.3693 14.5561C11.3693 14.6918 11.384 14.8229 11.4135 14.9493C11.443 15.0757 11.4849 15.2161 11.539 15.3705H12.9703C13.2673 15.4362 13.2673 15.8595 12.9703 15.9252H11.7087C11.7333 16.0328 11.7455 16.1335 11.7455 16.2271C11.7455 16.6811 11.5808 17.0743 11.2512 17.4066H13.9073Z", fill: "#051851" })));
};



;// CONCATENATED MODULE: ../../../packages/hermes-web-components/lib/icons/Accessibility/index.esm.js



const AccessibilityIcon = (props) => (react.createElement(SvgIcon_esm/* default */.Z, Object.assign({ width: "24", height: "25", viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    react.createElement("path", { d: "M9.7634 10.8047C9.05708 10.7925 8.35951 10.9623 7.73788 11.2979C7.11624 11.6335 6.59149 12.1235 6.21417 12.7207C5.83684 13.3179 5.61965 14.0023 5.58351 14.7078C5.54738 15.4133 5.69351 16.1162 6.00784 16.7488C6.32218 17.3815 6.79411 17.9225 7.37821 18.3199C7.9623 18.7172 8.63886 18.9575 9.34274 19.0175C10.0466 19.0775 10.7541 18.9552 11.397 18.6625C12.0399 18.3698 12.5967 17.9165 13.0136 17.3462M14.7004 6.69057C14.7004 7.12703 14.8737 7.5456 15.1824 7.85422C15.491 8.16284 15.9096 8.33622 16.346 8.33622C16.7825 8.33622 17.201 8.16284 17.5097 7.85422C17.8183 7.5456 17.9917 7.12703 17.9917 6.69057C17.9917 6.25412 17.8183 5.83554 17.5097 5.52692C17.201 5.2183 16.7825 5.04492 16.346 5.04492C15.9096 5.04492 15.491 5.2183 15.1824 5.52692C14.8737 5.83554 14.7004 6.25412 14.7004 6.69057Z", stroke: "#051851", strokeWidth: "1.4", strokeLinecap: "round", strokeLinejoin: "round", fill: "none" }),
    react.createElement("path", { d: "M17.9917 18.2099L14.7004 14.0957H11.409L13.8775 9.9816L10.5862 7.51312L7.29492 8.33595", stroke: "#051851", strokeWidth: "1.4", strokeLinecap: "round", strokeLinejoin: "round", fill: "none" })));



;// CONCATENATED MODULE: ../../../packages/hermes-web-components/lib/icons/Videotape/index.esm.js




const VideotapeIcon = (_a) => {
    var props = (0,_tslib_esm/* __rest */._)(_a, []);
    return (react.createElement(SvgIcon_esm/* default */.Z, Object.assign({ width: "24", height: "25", viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react.createElement("circle", { cx: "12", cy: "12.0928", r: "7.71836", stroke: "#051851", strokeWidth: "1.2", fill: "none" }),
        react.createElement("circle", { cx: "12.0005", cy: "7.86035", r: "1.43408", stroke: "#051851", fill: "none" }),
        react.createElement("circle", { cx: "11.9995", cy: "12.0928", r: "0.70459", fill: "#051851" }),
        react.createElement("circle", { cx: "8.1333", cy: "10.7383", r: "1.43408", stroke: "#051851", fill: "none" }),
        react.createElement("circle", { cx: "9.48486", cy: "15.3882", r: "1.43408", stroke: "#051851", fill: "none" }),
        react.createElement("circle", { cx: "15.8677", cy: "10.7383", r: "1.43408", stroke: "#051851", fill: "none" }),
        react.createElement("circle", { cx: "14.4419", cy: "15.3882", r: "1.43408", stroke: "#051851", fill: "none" }),
        react.createElement("path", { d: "M20.4336 21.0257C19.6682 20.437 17.5301 19.3374 15.1005 19.6483C12.671 19.9592 11.0277 19.7779 10.5098 19.6483", stroke: "#051851", strokeWidth: "1.2", strokeLinecap: "round" })));
};



;// CONCATENATED MODULE: ../../../packages/hermes-web-components/lib/icons/Cup/index.esm.js




const CupIcon = (_a) => {
    var props = (0,_tslib_esm/* __rest */._)(_a, []);
    return (react.createElement(SvgIcon_esm/* default */.Z, Object.assign({ width: "24", height: "25", viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react.createElement("path", { d: "M4.69141 11.1221H16.377C16.9293 11.1221 17.377 11.5698 17.377 12.1221V14.5137V17.0238C17.377 19.233 15.5861 21.0239 13.377 21.0239H7.69141C5.48227 21.0239 3.69141 19.233 3.69141 17.0239V12.1221C3.69141 11.5698 4.13912 11.1221 4.69141 11.1221Z", stroke: "#051851", strokeWidth: "1.2", fill: "none" }),
        react.createElement("path", { d: "M17.4277 12.5598H19.8642C20.9224 12.5598 21.6479 13.626 21.2595 14.6103L20.8385 15.6771C20.6679 16.1096 20.3063 16.4386 19.8596 16.5676L17.4277 17.2702", stroke: "#051851", strokeWidth: "1.2", fill: "none" }),
        react.createElement("path", { d: "M6.23273 15.3497C6.56411 15.3497 6.83273 15.0811 6.83273 14.7497C6.83273 14.4183 6.56411 14.1497 6.23273 14.1497V15.3497ZM3.74609 15.3497H6.23273V14.1497H3.74609V15.3497Z", fill: "#051851" }),
        react.createElement("path", { d: "M8.60156 14.7959L17.2834 14.7959", stroke: "#051851", strokeWidth: "1.2", strokeLinecap: "round" }),
        react.createElement("path", { d: "M8.43615 8.89456L7.96525 8.14678C7.58429 7.54181 7.69242 6.75068 8.22174 6.27012V6.27012C8.86599 5.68524 8.86599 4.67248 8.22174 4.0876L7.60946 3.53174", stroke: "#051851", strokeLinecap: "round" }),
        react.createElement("path", { d: "M11.9537 8.89456L11.4828 8.14678C11.1019 7.54181 11.21 6.75068 11.7393 6.27012V6.27012C12.3836 5.68524 12.3836 4.67248 11.7393 4.0876L11.127 3.53174", stroke: "#051851", strokeLinecap: "round" })));
};



;// CONCATENATED MODULE: ../../../packages/hermes-web-components/lib/icons/Dumbbell/index.esm.js




const DumbbellIcon = (_a) => {
    var props = (0,_tslib_esm/* __rest */._)(_a, []);
    return (react.createElement(SvgIcon_esm/* default */.Z, Object.assign({ width: "24", height: "25", viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react.createElement("rect", { x: "8.04297", y: "17.5235", width: "2.1208", height: "9.35502", rx: "1.0604", transform: "rotate(180 8.04297 17.5235)", stroke: "#051851", fill: "none" }),
        react.createElement("rect", { x: "15.959", y: "8.16846", width: "2.1208", height: "9.35502", rx: "1.0604", stroke: "#051851", fill: "none" }),
        react.createElement("path", { d: "M5.80469 15.946L5.49029 15.946C4.66187 15.946 3.99029 15.2744 3.99029 14.446L3.99029 11.246C3.99029 10.4176 4.66187 9.74601 5.49029 9.74601L5.80469 9.74601L5.80469 15.946Z", stroke: "#051851", fill: "none" }),
        react.createElement("path", { d: "M18.1973 9.74597L18.5117 9.74597C19.3401 9.74597 20.0117 10.4175 20.0117 11.246L20.0117 14.4459C20.0117 15.2744 19.3401 15.9459 18.5117 15.9459L18.1973 15.9459L18.1973 9.74597Z", stroke: "#051851", fill: "none" }),
        react.createElement("path", { d: "M3.79883 14.2834L3.14497 14.2834C2.59269 14.2834 2.14498 13.8357 2.14498 13.2834L2.14498 12.2982C2.14498 11.7459 2.59269 11.2982 3.14497 11.2982L3.79883 11.2982L3.79883 14.2834Z", stroke: "#051851", fill: "none" }),
        react.createElement("path", { d: "M20.2031 11.4086L20.857 11.4086C21.4093 11.4086 21.857 11.8563 21.857 12.4086L21.857 13.3938C21.857 13.9461 21.4093 14.3938 20.857 14.3938L20.2031 14.3938L20.2031 11.4086Z", stroke: "#051851", fill: "none" }),
        react.createElement("path", { d: "M15.8242 13.5384L8.16868 13.5384", stroke: "#051851", strokeLinecap: "round", strokeLinejoin: "round" }),
        react.createElement("path", { d: "M8.16724 11.608L13.0234 11.608", stroke: "#051851", strokeLinecap: "round", strokeLinejoin: "round" }),
        react.createElement("path", { d: "M14.6243 11.6044L15.8105 11.6044", stroke: "#051851", strokeLinecap: "round", strokeLinejoin: "round" })));
};



// EXTERNAL MODULE: ./utils/strings.ts
var strings = __webpack_require__(43601);
;// CONCATENATED MODULE: ./utils/extractFacilitiesTypes.ts


var facilitiesIcons = {
    general: BedIcon,
    paymentOptions: MoneyBagIcon,
    accessibility: AccessibilityIcon,
    leisureRecovery: VideotapeIcon,
    dining: CupIcon,
    wellbeingRehabilitation: DumbbellIcon
};
var extractFacilitiesTypes = function(facilities, locale) {
    var result = {};
    facilities === null || facilities === void 0 ? void 0 : facilities.forEach(function(item) {
        var ref;
        var subtype = (ref = item.Facility.data) === null || ref === void 0 ? void 0 : ref.subtype;
        var ref1;
        var subtypeKey = (0,strings/* camelCase */.eV)((ref1 = subtype === null || subtype === void 0 ? void 0 : subtype.key) !== null && ref1 !== void 0 ? ref1 : "");
        var type = item.Facility.type;
        var name = item.Facility.name;
        var subtypeName = (subtype === null || subtype === void 0 ? void 0 : subtype.name[locale]) || type;
        if (!result[subtypeName]) {
            var ref2;
            result[subtypeName] = {
                name: (subtype === null || subtype === void 0 ? void 0 : subtype.name) || {},
                type: type,
                Icon: (ref2 = facilitiesIcons === null || facilitiesIcons === void 0 ? void 0 : facilitiesIcons[subtypeKey]) !== null && ref2 !== void 0 ? ref2 : null,
                items: [],
                key: subtypeKey
            };
        }
        result[subtypeName].items.push({
            name: name,
            value: item.value || {},
            pinned: item.pinned
        });
    });
    var resultValues = Object.values(result);
    return {
        facilities: (resultValues === null || resultValues === void 0 ? void 0 : resultValues.filter(function(facility) {
            return facility.type === "Facilities";
        })) || [],
        services: (resultValues === null || resultValues === void 0 ? void 0 : resultValues.filter(function(facility) {
            return facility.type === "Services";
        })) || [],
        parking: (resultValues === null || resultValues === void 0 ? void 0 : resultValues.filter(function(facility) {
            return facility.type === "Parking";
        })) || [],
        pinned: (facilities === null || facilities === void 0 ? void 0 : facilities.filter(function(facility) {
            return facility.pinned;
        })) || []
    };
};
/* harmony default export */ var utils_extractFacilitiesTypes = (extractFacilitiesTypes);


/***/ }),

/***/ 80677:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ filteringProfileDataByPlan; }
/* harmony export */ });
/* harmony import */ var _getImageWithWWW__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85666);
/* harmony import */ var _constants_profile__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77225);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}


var UNCLAIMED_PLANS = [
    _constants_profile__WEBPACK_IMPORTED_MODULE_0__/* .PracticePlans.UNCLAIMED */ .cj.UNCLAIMED,
    _constants_profile__WEBPACK_IMPORTED_MODULE_0__/* .SpecialistPlans.UNCLAIMED */ .FS.UNCLAIMED
];
var BASIC_PLANS = [
    _constants_profile__WEBPACK_IMPORTED_MODULE_0__/* .PracticePlans.ENTRY */ .cj.ENTRY,
    _constants_profile__WEBPACK_IMPORTED_MODULE_0__/* .SpecialistPlans.ENTRY */ .FS.ENTRY
];
var PRO_PLANS = [
    _constants_profile__WEBPACK_IMPORTED_MODULE_0__/* .PracticePlans.ESSENTIALS */ .cj.ESSENTIALS,
    _constants_profile__WEBPACK_IMPORTED_MODULE_0__/* .PracticePlans.PRO */ .cj.PRO,
    _constants_profile__WEBPACK_IMPORTED_MODULE_0__/* .SpecialistPlans.EXPERT */ .FS.EXPERT,
    _constants_profile__WEBPACK_IMPORTED_MODULE_0__/* .SpecialistPlans.EXPERT_PRO */ .FS.EXPERT_PRO
];
// todo: fix complexity
// eslint-disable-next-line complexity
var filteringProfileDataByPlan = function(param) {
    var practice = param.practice, specialist = param.specialist, specialistPractice = param.specialistPractice, practiceSpecialist = param.practiceSpecialist;
    var profile = practice || specialist || specialistPractice || practiceSpecialist;
    var isUnclaimed = UNCLAIMED_PLANS.some(function(plan) {
        return profile === null || profile === void 0 ? void 0 : profile.plan.includes(plan);
    });
    var isBasic = BASIC_PLANS.some(function(plan) {
        return profile === null || profile === void 0 ? void 0 : profile.plan.includes(plan);
    });
    var isPro = PRO_PLANS.some(function(plan) {
        return profile === null || profile === void 0 ? void 0 : profile.plan.includes(plan);
    });
    if (practice) {
        var ref, ref1, ref2, ref3, ref4;
        var transformedPractice = _objectSpread({}, practice);
        delete transformedPractice.reviewCode;
        delete transformedPractice.followersCount;
        var imagesWithWWW = {
            cover: (0,_getImageWithWWW__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((practice === null || practice === void 0 ? void 0 : (ref = practice.images) === null || ref === void 0 ? void 0 : ref.cover) || ""),
            logo: (0,_getImageWithWWW__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((practice === null || practice === void 0 ? void 0 : (ref1 = practice.images) === null || ref1 === void 0 ? void 0 : ref1.logo) || ""),
            images: (practice === null || practice === void 0 ? void 0 : (ref2 = practice.images) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.images) === null || ref3 === void 0 ? void 0 : ref3.map(function(href) {
                return (0,_getImageWithWWW__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(href);
            })) || []
        };
        var resultPractice = _objectSpread({}, transformedPractice, {
            images: imagesWithWWW,
            reviewObject: _objectSpread({}, practice.reviewObject),
            specialists: ((ref4 = practice.specialists) === null || ref4 === void 0 ? void 0 : ref4.map(function(pr) {
                return filteringProfileDataByPlan({
                    practiceSpecialist: pr
                });
            })) || []
        });
        if (isBasic || isUnclaimed) {
            resultPractice.averageRating = 0;
            resultPractice.reviewsTotal = 0;
            resultPractice.overallExperience = 0;
            resultPractice.lastReview = null;
            resultPractice.images.logo = "";
            resultPractice.images.cover = "";
            resultPractice.insurers = [];
            resultPractice.reviewObject = {
                overallExperience: 0,
                reviewsTotal: 0,
                averageRating: 0,
                bedsideManner: 0,
                careAndSupport: 0,
                cleanliness: 0,
                explanation: 0,
                facilities: 0,
                friendliness: 0,
                waitTime: 0
            };
        }
        if (isPro) {
            resultPractice.followersCount = practice.followersCount;
        }
        return resultPractice;
    }
    if (practiceSpecialist) {
        var ref5;
        var transformedPracticeSpecialist = _objectSpread({}, practiceSpecialist);
        delete transformedPracticeSpecialist.reviewCode;
        delete transformedPracticeSpecialist.authenticationToken;
        var imagesWithWWW1 = {
            logo: (0,_getImageWithWWW__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((practiceSpecialist === null || practiceSpecialist === void 0 ? void 0 : (ref5 = practiceSpecialist.images) === null || ref5 === void 0 ? void 0 : ref5.logo) || "")
        };
        var resultPracticeSpecialist = _objectSpread({}, transformedPracticeSpecialist, {
            images: imagesWithWWW1,
            review: _objectSpread({}, practiceSpecialist.review)
        });
        if (isBasic || isUnclaimed) {
            resultPracticeSpecialist.averageRating = 0;
            resultPracticeSpecialist.reviewsTotal = 0;
            resultPracticeSpecialist.overallExperience = 0;
            resultPracticeSpecialist.explanation = 0;
            resultPracticeSpecialist.bedsideManner = 0;
            resultPracticeSpecialist.averageRating = 0;
            resultPracticeSpecialist.lastReview = null;
            resultPracticeSpecialist.images.logo = "";
            resultPracticeSpecialist.insurers = [];
            resultPracticeSpecialist.review = {
                overallExperience: 0,
                reviewsTotal: 0,
                averageRating: 0,
                bedsideManner: 0,
                careAndSupport: 0,
                cleanliness: 0,
                explanation: 0,
                facilities: 0,
                friendliness: 0,
                waitTime: 0
            };
        }
        if (isUnclaimed) {
            resultPracticeSpecialist.registrationBodies = [];
        }
        return resultPracticeSpecialist;
    }
    if (specialist) {
        var ref6, ref7, ref8, ref9, ref10;
        var transformedSpecialist = _objectSpread({}, specialist);
        delete transformedSpecialist.reviewCode;
        delete transformedSpecialist.authenticationToken;
        var imagesWithWWW2 = {
            logo: (0,_getImageWithWWW__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((specialist === null || specialist === void 0 ? void 0 : (ref6 = specialist.images) === null || ref6 === void 0 ? void 0 : ref6.logo) || ""),
            images: (specialist === null || specialist === void 0 ? void 0 : (ref7 = specialist.images) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.images) === null || ref8 === void 0 ? void 0 : ref8.map(function(href) {
                return (0,_getImageWithWWW__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(href);
            })) || []
        };
        var resultSpecialist = _objectSpread({}, transformedSpecialist, {
            images: imagesWithWWW2,
            review: _objectSpread({}, specialist.review),
            practices: ((ref9 = specialist.practices) === null || ref9 === void 0 ? void 0 : ref9.map(function(pr) {
                return filteringProfileDataByPlan({
                    specialistPractice: pr
                });
            })) || []
        });
        resultSpecialist.peerRecommendations = (resultSpecialist === null || resultSpecialist === void 0 ? void 0 : (ref10 = resultSpecialist.peerRecommendations) === null || ref10 === void 0 ? void 0 : ref10.slice(0, 3)) || [];
        if (isBasic || isUnclaimed) {
            resultSpecialist.averageRating = 0;
            resultSpecialist.reviewsTotal = 0;
            resultSpecialist.overallExperience = 0;
            resultSpecialist.lastReview = null;
            resultSpecialist.insurers = [];
            resultSpecialist.review = {
                overallExperience: 0,
                reviewsTotal: 0,
                averageRating: 0,
                bedsideManner: 0,
                careAndSupport: 0,
                cleanliness: 0,
                explanation: 0,
                facilities: 0,
                friendliness: 0,
                waitTime: 0
            };
        }
        if (isUnclaimed) {
            resultSpecialist.registrationBodies = [];
        }
        return resultSpecialist;
    }
    if (specialistPractice) {
        var ref11, ref12, ref13, ref14;
        var transformedSpecialistPractice = _objectSpread({}, specialistPractice);
        delete transformedSpecialistPractice.reviewCode;
        delete transformedSpecialistPractice.authenticationToken;
        var imagesWithWWW3 = {
            cover: (0,_getImageWithWWW__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((specialistPractice === null || specialistPractice === void 0 ? void 0 : (ref11 = specialistPractice.images) === null || ref11 === void 0 ? void 0 : ref11.cover) || ""),
            logo: (0,_getImageWithWWW__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((specialistPractice === null || specialistPractice === void 0 ? void 0 : (ref12 = specialistPractice.images) === null || ref12 === void 0 ? void 0 : ref12.logo) || ""),
            images: (specialistPractice === null || specialistPractice === void 0 ? void 0 : (ref13 = specialistPractice.images) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.images) === null || ref14 === void 0 ? void 0 : ref14.map(function(href) {
                return (0,_getImageWithWWW__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(href);
            })) || []
        };
        var resultSpecialistPractice = _objectSpread({}, transformedSpecialistPractice, {
            images: imagesWithWWW3,
            reviews: _objectSpread({}, specialistPractice.reviews)
        });
        if (isBasic || isUnclaimed) {
            resultSpecialistPractice.images.logo = "";
            resultSpecialistPractice.reviews = {
                overallExperience: 0,
                reviewsTotal: 0,
                averageRating: 0,
                bedsideManner: 0,
                careAndSupport: 0,
                cleanliness: 0,
                explanation: 0,
                facilities: 0,
                friendliness: 0,
                waitTime: 0
            };
        }
        return resultSpecialistPractice;
    }
    return undefined;
};


/***/ }),

/***/ 27790:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "UD": function() { return /* binding */ compareLocationSlugs; },
/* harmony export */   "ym": function() { return /* binding */ extractLocationProps; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var extractLocationProps = function(str) {
    if (str.startsWith("ext-")) {
        var ref = _slicedToArray(str.split("ext-"), 2), latLonLocation = ref[1];
        var params = [];
        var value = "";
        for(var i = 0; i < latLonLocation.length; i += 1){
            if (latLonLocation[i] !== "-" || value.length === 0) {
                value += latLonLocation[i];
            } else {
                params.push(value);
                value = "";
            }
            if (i === latLonLocation.length - 1) {
                params.push(value);
            }
        }
        return {
            lat: (params === null || params === void 0 ? void 0 : params[0]) || "",
            lon: (params === null || params === void 0 ? void 0 : params[1]) || ""
        };
    }
    return {
        lat: "51.4776721",
        lon: "0.1648559"
    };
};
var compareLocationSlugs = function(a, b) {
    return a === b;
};
var findLocation = function(defaultLocations, urlLocation) {
    return defaultLocations.find(function(f) {
        return compareLocationSlugs(urlLocation, f.slug);
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (findLocation);


/***/ }),

/***/ 82762:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var getImageFromNextImage = function(url) {
    return "/_next/image?url=".concat(encodeURIComponent(url || ""), "&w=256&q=75");
};
/* harmony default export */ __webpack_exports__["Z"] = (getImageFromNextImage);


/***/ }),

/***/ 84990:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ practiceSpecialistSort; },
/* harmony export */   "V": function() { return /* binding */ getPracticeSpecialistName; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var practiceSpecialistSort = function(specialists) {
    return _toConsumableArray(specialists.filter(function(_, index) {
        return index % 2 === 0;
    })).concat(_toConsumableArray(specialists.filter(function(_, index) {
        return index % 2 !== 0;
    })));
};
var getPracticeSpecialistName = function(specialist, language) {
    var ref, ref1, ref2;
    return [
        specialist === null || specialist === void 0 ? void 0 : (ref = specialist.title) === null || ref === void 0 ? void 0 : ref[language],
        specialist === null || specialist === void 0 ? void 0 : (ref1 = specialist.firstName) === null || ref1 === void 0 ? void 0 : ref1[language],
        specialist === null || specialist === void 0 ? void 0 : (ref2 = specialist.lastName) === null || ref2 === void 0 ? void 0 : ref2[language]
    ].filter(function(n) {
        return !!n;
    }).join(" ");
};


/***/ }),

/***/ 43395:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getAddressSchema; }
/* harmony export */ });
function getAddressSchema(address, lang) {
    var ref, ref1, ref2;
    return {
        "@type": "PostalAddress",
        addressCountry: address === null || address === void 0 ? void 0 : (ref = address.country) === null || ref === void 0 ? void 0 : ref[lang],
        addressLocality: address === null || address === void 0 ? void 0 : (ref1 = address.city) === null || ref1 === void 0 ? void 0 : ref1[lang],
        postalCode: address === null || address === void 0 ? void 0 : (ref2 = address.postcode) === null || ref2 === void 0 ? void 0 : ref2[lang],
        streetAddress: [
            address === null || address === void 0 ? void 0 : address.street1,
            address === null || address === void 0 ? void 0 : address.street2
        ].map(function(i) {
            return i === null || i === void 0 ? void 0 : i[lang];
        }).filter(function(i) {
            return !!i;
        }).join(" ")
    };
};


/***/ }),

/***/ 70485:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var transformSpecialists = function(specialists) {
    return specialists.map(function(spec) {
        var ref;
        return _objectSpread({}, spec, {
            // todo: temporary big page size fix
            // Keywords and practices from specialist currently is not in use but increase the page size significantly.
            // Keep this solution unless we figure out how to deal with big amount of data in keywords.
            keywords: (ref = spec.keywords) === null || ref === void 0 ? void 0 : ref.filter(function(keyword) {
                return keyword.isTopLevelChild && keyword.keywordType === "specialty";
            }),
            keywords_search: [],
            practices: _toConsumableArray(spec.practices).sort(function(a, b) {
                return b.reviews.reviewsTotal - a.reviews.reviewsTotal;
            }).sort(function(a, b) {
                return b.practiceSortOrder - a.practiceSortOrder;
            }),
            insurers: [],
            connections: {},
            about: {},
            education: {}
        });
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (transformSpecialists);


/***/ }),

/***/ 16697:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CheckboxCircle; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_esm_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10395);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32735);
/* harmony import */ var _node_modules_mui_material_SvgIcon_SvgIcon_esm_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46224);




const CheckboxCircle = (_a) => {
    var props = (0,_virtual_tslib_esm_js__WEBPACK_IMPORTED_MODULE_1__/* .__rest */ ._)(_a, []);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_node_modules_mui_material_SvgIcon_SvgIcon_esm_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", fill: "none", viewBox: "0 0 20 20" }, props),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "#008579", fillRule: "evenodd", d: "M19.167 10A9.167 9.167 0 11.833 10a9.167 9.167 0 0118.334 0zM5 10.35l1.175-1.175 2.158 2.15 5.492-5.492L15 7.017l-6.667 6.666L5 10.35z", clipRule: "evenodd" })));
};




/***/ })

}]);